/* eslint-disable max-len */
export const YES_NO_OPTIONS = [
  {value: 'Yes', label: 'Yes'},
  {value: 'No', label: 'No'}
];

const COUNTRY_CODE_NAME: Array<{code: string; name: string}> = [
  {code: 'AFN', name: 'Afghani'},
  {code: 'AF', name: 'Afghanistan'},
  {code: 'AX', name: 'ÅLAND ISLANDS'},
  {code: 'AL', name: 'Albania'},
  {code: 'DZ', name: 'Algeria'},
  {code: 'DZD', name: 'Algerian Dinar'},
  {code: 'XA', name: 'American Oceania'},
  {code: 'AS', name: 'American Samoa'},
  {code: 'AD', name: 'Andorra'},
  {code: 'AO', name: 'Angola'},
  {code: 'AI', name: 'Anguilla'},
  {code: 'AG', name: 'Antigua and Barbuda'},
  {code: 'AR', name: 'Argentina'},
  {code: 'ARS', name: 'Argentine Peso'},
  {code: 'AM', name: 'Armenia'},
  {code: 'AMD', name: 'Armenian Dram'},
  {code: 'AW', name: 'Aruba'},
  {code: 'AQ', name: 'Aruban Florin'},
  {code: 'AWG', name: 'Aruban Florin'},
  {code: 'AU', name: 'Australia'},
  {code: 'AUD', name: 'Australian Dollar'},
  {code: 'XO', name: 'Australian Oceania'},
  {code: 'AT', name: 'Austria'},
  {code: 'AZ', name: 'Azerbaijan'},
  {code: 'AZN', name: 'Azerbaijan Manat'},
  {code: 'BS', name: 'Bahamas'},
  {code: 'BSD', name: 'Bahamian Dollar'},
  {code: 'BH', name: 'Bahrain'},
  {code: 'BHD', name: 'Bahraini Dinar'},
  {code: 'THB', name: 'Baht'},
  {code: 'PAB', name: 'Balboa'},
  {code: 'BD', name: 'Bangladesh'},
  {code: 'BB', name: 'Barbados'},
  {code: 'BBD', name: 'Barbados Dollar'},
  {code: 'BY', name: 'Belarus'},
  {code: 'BYN', name: 'Belarusian Ruble'},
  {code: 'BE', name: 'Belgium'},
  {code: 'BZ', name: 'Belize'},
  {code: 'BZD', name: 'Belize Dollar'},
  {code: 'BJ', name: 'Benin'},
  {code: 'BM', name: 'Bermuda'},
  {code: 'BMD', name: 'Bermudian Dollar'},
  {code: 'BT', name: 'Bhutan'},
  {code: 'VES', name: 'Bolivar Soberano'},
  {code: 'VED', name: 'Bolívar Soberano'},
  {code: 'BO', name: 'Bolivia, Plurinational State of'},
  {code: 'BOB', name: 'Boliviano'},
  {code: 'BQ', name: 'Bonaire, Sint Eustatius and Saba'},
  {code: 'BA', name: 'Bosnia and Herzegovina'},
  {code: 'BW', name: 'Botswana'},
  {code: 'BV', name: 'Bouvet Island'},
  {code: 'BR', name: 'Brazil'},
  {code: 'BRL', name: 'Brazilian Real'},
  {code: 'IO', name: 'British Indian Ocean Territory'},
  {code: 'VG', name: 'British Virgin Islands'},
  {code: 'BN', name: 'Brunei Darussalam'},
  {code: 'BND', name: 'Brunei Dollar'},
  {code: 'BG', name: 'Bulgaria'},
  {code: 'BGN', name: 'Bulgarian Lev'},
  {code: 'BF', name: 'Burkina Faso'},
  {code: 'BI', name: 'Burundi'},
  {code: 'BIF', name: 'Burundi Franc'},
  {code: 'CVE', name: 'Cabo Verde Escudo'},
  {code: 'KH', name: 'Cambodia'},
  {code: 'CM', name: 'Cameroon'},
  {code: 'CA', name: 'Canada'},
  {code: 'CAD', name: 'Canadian Dollar'},
  {code: 'CV', name: 'Cape Verde'},
  {code: 'KY', name: 'Cayman Islands'},
  {code: 'KYD', name: 'Cayman Islands Dollar'},
  {code: 'CF', name: 'Central African Republic'},
  {code: 'XC', name: 'Ceuta'},
  {code: 'XOF', name: 'CFA Franc BCEAO'},
  {code: 'XAF', name: 'CFA Franc BEAC'},
  {code: 'XPF', name: 'CFP Franc'},
  {code: 'TD', name: 'Chad'},
  {code: 'CL', name: 'Chile'},
  {code: 'CLP', name: 'Chilean Peso'},
  {code: 'CN', name: 'China'},
  {code: 'CX', name: 'Christmas Island'},
  {code: 'CC', name: 'Cocos Islands (or Keeling Islands)'},
  {code: 'CO', name: 'Colombia'},
  {code: 'COP', name: 'Colombian Peso'},
  {code: 'KMF', name: 'Comorian Franc'},
  {code: 'KM', name: 'Comoros'},
  {code: 'CG', name: 'Congo'},
  {code: 'CD', name: 'Congo, Democratic Republic of'},
  {code: 'CDF', name: 'Congolese Franc'},
  {code: 'BAM', name: 'Convertible Mark'},
  {code: 'CK', name: 'Cook Islands'},
  {code: 'NIO', name: 'Cordoba Oro'},
  {code: 'CR', name: 'Costa Rica'},
  {code: 'CRC', name: 'Costa Rican Colon'},
  {code: 'CI', name: 'Cote d Ivoire'},
  {code: 'HR', name: 'Croatia'},
  {code: 'CU', name: 'Cuba'},
  {code: 'CUP', name: 'Cuban Peso'},
  {code: 'CW', name: 'Curaçao'},
  {code: 'CY', name: 'Cyprus'},
  {code: 'CZK', name: 'Czech Koruna'},
  {code: 'CZ', name: 'Czechia'},
  {code: 'GMD', name: 'Dalasi'},
  {code: 'DKK', name: 'Danish Krone'},
  {code: 'MKD', name: 'Denar'},
  {code: 'DK', name: 'Denmark'},
  {code: 'DJ', name: 'Djibouti'},
  {code: 'DJF', name: 'Djibouti Franc'},
  {code: 'STN', name: 'Dobra'},
  {code: 'DM', name: 'Dominica'},
  {code: 'DOP', name: 'Dominican Peso'},
  {code: 'DO', name: 'Dominican Republic'},
  {code: 'VND', name: 'Dong'},
  {code: 'XCD', name: 'East Caribbean Dollar'},
  {code: 'TP', name: 'East Timor'},
  {code: 'EC', name: 'Ecuador'},
  {code: 'EG', name: 'Egypt'},
  {code: 'EGP', name: 'Egyptian Pound'},
  {code: 'SV', name: 'El Salvador'},
  {code: 'SVC', name: 'El Salvador Colon'},
  {code: 'GQ', name: 'Equatorial Guinea'},
  {code: 'ER', name: 'Eritrea'},
  {code: 'EE', name: 'Estonia'},
  {code: 'ET', name: 'Ethiopia'},
  {code: 'ETB', name: 'Ethiopian Birr'},
  {code: 'EUR', name: 'Euro'},
  {code: 'EU', name: 'European Community'},
  {code: 'FK', name: 'Falkland Islands'},
  {code: 'FKP', name: 'Falkland Islands Pound'},
  {code: 'FO', name: 'Faroe Islands'},
  {code: 'YU', name: 'Federal Republic of Yugoslavia'},
  {code: 'FJ', name: 'Fiji'},
  {code: 'FJD', name: 'Fiji Dollar'},
  {code: 'FI', name: 'Finland'},
  {code: 'HUF', name: 'Forint'},
  {code: 'FR', name: 'France'},
  {code: 'GF', name: 'French Guyana'},
  {code: 'PF', name: 'French Polynesia'},
  {code: 'TF', name: 'French Southern Territories'},
  {code: 'GA', name: 'Gabon'},
  {code: 'GM', name: 'Gambia'},
  {code: 'GE', name: 'Georgia'},
  {code: 'DE', name: 'Germany'},
  {code: 'GH', name: 'Ghana'},
  {code: 'GHS', name: 'Ghana Cedi'},
  {code: 'GI', name: 'Gibraltar'},
  {code: 'GIP', name: 'Gibraltar Pound'},
  {code: 'HTG', name: 'Gourde'},
  {code: 'GR', name: 'Greece'},
  {code: 'GL', name: 'Greenland'},
  {code: 'GD', name: 'Grenada'},
  {code: 'GP', name: 'Guadeloupe'},
  {code: 'GU', name: 'Guam'},
  {code: 'PYG', name: 'Guarani'},
  {code: 'GT', name: 'Guatemala'},
  {code: 'GG', name: 'Guernsey'},
  {code: 'GN', name: 'Guinea'},
  {code: 'GW', name: 'Guinea-Bissau'},
  {code: 'GNF', name: 'Guinean Franc'},
  {code: 'GY', name: 'Guyana'},
  {code: 'GYD', name: 'Guyana Dollar'},
  {code: 'HT', name: 'Haiti'},
  {code: 'HM', name: 'Heard Island and McDonald Islands'},
  {code: 'QP', name: 'High seas'},
  {code: 'HN', name: 'Honduras'},
  {code: 'HK', name: 'Hong Kong'},
  {code: 'HKD', name: 'Hong Kong Dollar'},
  {code: 'UAH', name: 'Hryvnia'},
  {code: 'HU', name: 'Hungary'},
  {code: 'IS', name: 'Iceland'},
  {code: 'ISK', name: 'Iceland Krona'},
  {code: 'IN', name: 'India'},
  {code: 'INR', name: 'Indian Rupee'},
  {code: 'ID', name: 'Indonesia'},
  {code: 'IR', name: 'Iran, Islamic Republic of'},
  {code: 'IRR', name: 'Iranian Rial'},
  {code: 'IQ', name: 'Iraq'},
  {code: 'IQD', name: 'Iraqi Dinar'},
  {code: 'IE', name: 'Ireland'},
  {code: 'IM', name: 'Isle of Man'},
  {code: 'IL', name: 'Israel'},
  {code: 'IT', name: 'Italy'},
  {code: 'JM', name: 'Jamaica'},
  {code: 'JMD', name: 'Jamaican Dollar'},
  {code: 'JP', name: 'Japan'},
  {code: 'JE', name: 'Jersey'},
  {code: 'JO', name: 'Jordan'},
  {code: 'JOD', name: 'Jordanian Dinar'},
  {code: 'KZ', name: 'Kazakhstan'},
  {code: 'KE', name: 'Kenya'},
  {code: 'KES', name: 'Kenyan Shilling'},
  {code: 'PGK', name: 'Kina'},
  {code: 'KI', name: 'Kiribati'},
  {code: 'KP', name: 'Korea, Democratic People’s Republ'},
  {code: 'KR', name: 'Korea, Republic of'},
  {code: 'XK', name: 'Kosovo'},
  {code: 'KW', name: 'Kuwait'},
  {code: 'KWD', name: 'Kuwaiti Dinar'},
  {code: 'AOA', name: 'Kwanza'},
  {code: 'MMK', name: 'Kyat'},
  {code: 'KG', name: 'Kyrgyz, Republic'},
  {code: 'LAK', name: 'Lao Kip'},
  {code: 'LA', name: 'Lao People’s Democratic Republic'},
  {code: 'GEL', name: 'Lari'},
  {code: 'LV', name: 'Latvia'},
  {code: 'LBP', name: 'Lebanese Pound'},
  {code: 'LB', name: 'Lebanon'},
  {code: 'ALL', name: 'Lek'},
  {code: 'HNL', name: 'Lempira'},
  {code: 'SLE', name: 'Leone'},
  {code: 'SLL', name: 'Leone'},
  {code: 'LS', name: 'Lesotho'},
  {code: 'LR', name: 'Liberia'},
  {code: 'LRD', name: 'Liberian Dollar'},
  {code: 'LY', name: 'Libya'},
  {code: 'LYD', name: 'Libyan Dinar'},
  {code: 'LI', name: 'Liechtenstein'},
  {code: 'SZL', name: 'Lilangeni'},
  {code: 'LT', name: 'Lithuania'},
  {code: 'LSL', name: 'Loti'},
  {code: 'LU', name: 'Luxembourg'},
  {code: 'MO', name: 'Macao'},
  {code: 'MG', name: 'Madagascar'},
  {code: 'MGA', name: 'Malagasy Ariary'},
  {code: 'MW', name: 'Malawi'},
  {code: 'MWK', name: 'Malawi Kwacha'},
  {code: 'MY', name: 'Malaysia'},
  {code: 'MYR', name: 'Malaysian Ringgit'},
  {code: 'MV', name: 'Maldives'},
  {code: 'ML', name: 'Mali'},
  {code: 'MT', name: 'Malta'},
  {code: 'MH', name: 'Marshall Islands'},
  {code: 'MQ', name: 'Martinique'},
  {code: 'MR', name: 'Mauritania'},
  {code: 'MU', name: 'Mauritius'},
  {code: 'MUR', name: 'Mauritius Rupee'},
  {code: 'YT', name: 'Mayotte'},
  {code: 'XL', name: 'Melilla'},
  {code: 'MXN', name: 'Mexican Peso'},
  {code: 'MXV', name: 'Mexican Unidad de Inversion (UDI)'},
  {code: 'MX', name: 'Mexico'},
  {code: 'FM', name: 'Micronesia, Federated States of'},
  {code: 'MD', name: 'Moldova, Republic of'},
  {code: 'MDL', name: 'Moldovan Leu'},
  {code: 'MC', name: 'Monaco'},
  {code: 'MN', name: 'Mongolia'},
  {code: 'ME', name: 'Montenegro'},
  {code: 'XM', name: 'Montenegro'},
  {code: 'MS', name: 'Montserrat'},
  {code: 'MAD', name: 'Moroccan Dirham'},
  {code: 'MA', name: 'Morocco'},
  {code: 'MZ', name: 'Mozambique'},
  {code: 'MZN', name: 'Mozambique Metical'},
  {code: 'BOV', name: 'Mvdol'},
  {code: 'MM', name: 'Myanmar'},
  {code: 'NGN', name: 'Naira'},
  {code: 'ERN', name: 'Nakfa'},
  {code: 'NA', name: 'Namibia'},
  {code: 'NAD', name: 'Namibia Dollar'},
  {code: 'NR', name: 'Nauru'},
  {code: 'NP', name: 'Nepal'},
  {code: 'NPR', name: 'Nepalese Rupee'},
  {code: 'NL', name: 'Netherlands'},
  {code: 'ANG', name: 'Netherlands Antillean Guilder'},
  {code: 'AN', name: 'Netherlands Antilles'},
  {code: 'NC', name: 'New Caledonia'},
  {code: 'ILS', name: 'New Israeli Sheqel'},
  {code: 'TWD', name: 'New Taiwan Dollar'},
  {code: 'NZ', name: 'New Zealand'},
  {code: 'NZD', name: 'New Zealand Dollar'},
  {code: 'XZ', name: 'New Zealand Oceania'},
  {code: 'BTN', name: 'Ngultrum'},
  {code: 'NI', name: 'Nicaragua'},
  {code: 'NE', name: 'Niger'},
  {code: 'NG', name: 'Nigeria'},
  {code: 'NU', name: 'Niue'},
  {code: 'NF', name: 'Norfolk Island'},
  {code: 'KPW', name: 'North Korean Won'},
  {code: 'MK', name: 'North Macedonia'},
  {code: 'MP', name: 'Northern Mariana Islands'},
  {code: 'NO', name: 'Norway'},
  {code: 'NOK', name: 'Norwegian Krone'},
  {code: 'PS', name: 'Occupied Palestinian Territory'},
  {code: 'OM', name: 'Oman'},
  {code: 'MRU', name: 'Ouguiya'},
  {code: 'TOP', name: 'Pa’anga'},
  {code: 'PK', name: 'Pakistan'},
  {code: 'PKR', name: 'Pakistan Rupee'},
  {code: 'PW', name: 'Palau'},
  {code: 'PA', name: 'Panama'},
  {code: 'PG', name: 'Papua New Guinea'},
  {code: 'PY', name: 'Paraguay'},
  {code: 'MOP', name: 'Pataca'},
  {code: 'PE', name: 'Peru'},
  {code: 'CUC', name: 'Peso Convertible'},
  {code: 'UYU', name: 'Peso Uruguayo'},
  {code: 'PHP', name: 'Philippine Peso'},
  {code: 'PH', name: 'Philippines'},
  {code: 'PN', name: 'Pitcairn'},
  {code: 'PL', name: 'Poland'},
  {code: 'XR', name: 'Polar regions'},
  {code: 'PT', name: 'Portugal'},
  {code: 'GBP', name: 'Pound Sterling'},
  {code: 'PR', name: 'Puerto Rico'},
  {code: 'BWP', name: 'Pula'},
  {code: 'QA', name: 'Qatar'},
  {code: 'QAR', name: 'Qatari Rial'},
  {code: 'GTQ', name: 'Quetzal'},
  {code: 'ZAR', name: 'Rand'},
  {code: 'RE', name: 'Réunion'},
  {code: 'OMR', name: 'Rial Omani'},
  {code: 'KHR', name: 'Riel'},
  {code: 'RO', name: 'Romania'},
  {code: 'RON', name: 'Romanian Leu'},
  {code: 'MVR', name: 'Rufiyaa'},
  {code: 'IDR', name: 'Rupiah'},
  {code: 'RU', name: 'Russian Federation'},
  {code: 'RUB', name: 'Russian Ruble'},
  {code: 'RW', name: 'Rwanda'},
  {code: 'RWF', name: 'Rwanda Franc'},
  {code: 'BL', name: 'Saint Barthélemy'},
  {code: 'SHP', name: 'Saint Helena Pound'},
  {code: 'SH', name: 'Saint Helena, Ascension and Tristan'},
  {code: 'MF', name: 'Saint Martin (French part)'},
  {code: 'WS', name: 'Samoa'},
  {code: 'SM', name: 'San Marino'},
  {code: 'ST', name: 'Sao Tome and Principe'},
  {code: 'SA', name: 'Saudi Arabia'},
  {code: 'SAR', name: 'Saudi Riyal'},
  {code: 'XDR', name: 'SDR (Special Drawing Right)'},
  {code: 'SN', name: 'Senegal'},
  {code: 'RS', name: 'Serbia'},
  {code: 'XS', name: 'Serbia'},
  {code: 'RSD', name: 'Serbian Dinar'},
  {code: 'SC', name: 'Seychelles'},
  {code: 'SCR', name: 'Seychelles Rupee'},
  {code: 'SL', name: 'Sierra Leone'},
  {code: 'SG', name: 'Singapore'},
  {code: 'SGD', name: 'Singapore Dollar'},
  {code: 'SX', name: 'Sint Maarten (Dutch part)'},
  {code: 'SK', name: 'Slovakia'},
  {code: 'SI', name: 'Slovenia'},
  {code: 'PEN', name: 'Sol'},
  {code: 'SB', name: 'Solomon Islands'},
  {code: 'SBD', name: 'Solomon Islands Dollar'},
  {code: 'KGS', name: 'Som'},
  {code: 'SOS', name: 'Somali Shilling'},
  {code: 'SO', name: 'Somalia'},
  {code: 'TJS', name: 'Somoni'},
  {code: 'ZA', name: 'South Africa'},
  {code: 'GS', name: 'South Georgia and South Sandwich'},
  {code: 'SS', name: 'South Sudan'},
  {code: 'SSP', name: 'South Sudanese Pound'},
  {code: 'ES', name: 'Spain'},
  {code: 'LK', name: 'Sri Lanka'},
  {code: 'LKR', name: 'Sri Lanka Rupee'},
  {code: 'KN', name: 'St Kitts and Nevis'},
  {code: 'LC', name: 'St Lucia'},
  {code: 'PM', name: 'St Pierre and Miquelon'},
  {code: 'VC', name: 'St Vincent'},
  {code: 'SD', name: 'Sudan'},
  {code: 'SDG', name: 'Sudanese Pound'},
  {code: 'SRD', name: 'Surinam Dollar'},
  {code: 'SR', name: 'Suriname'},
  {code: 'SJ', name: 'Svalbard and Jan Mayen Islands'},
  {code: 'SZ', name: 'Swaziland'},
  {code: 'SE', name: 'Sweden'},
  {code: 'SEK', name: 'Swedish Krona'},
  {code: 'CHF', name: 'Swiss Franc'},
  {code: 'CH', name: 'Switzerland'},
  {code: 'SY', name: 'Syrian Arab Republic'},
  {code: 'SYP', name: 'Syrian Pound'},
  {code: 'TW', name: 'Taiwan'},
  {code: 'TJ', name: 'Tajikistan'},
  {code: 'BDT', name: 'Taka'},
  {code: 'WST', name: 'Tala'},
  {code: 'TZ', name: 'Tanzania, United Republic of'},
  {code: 'TZS', name: 'Tanzanian Shilling'},
  {code: 'KZT', name: 'Tenge'},
  {code: 'TH', name: 'Thailand'},
  {code: 'TL', name: 'Timor-Leste'},
  {code: 'TG', name: 'Togo'},
  {code: 'TK', name: 'Tokelau'},
  {code: 'TO', name: 'Tonga'},
  {code: 'TT', name: 'Trinidad and Tobago'},
  {code: 'TTD', name: 'Trinidad and Tobago Dollar'},
  {code: 'MNT', name: 'Tugrik'},
  {code: 'TN', name: 'Tunisia'},
  {code: 'TND', name: 'Tunisian Dinar'},
  {code: 'TRY', name: 'Turkish Lira'},
  {code: 'TR', name: 'Türkiye'},
  {code: 'TM', name: 'Turkmenistan'},
  {code: 'TMT', name: 'Turkmenistan New Manat'},
  {code: 'TC', name: 'Turks and Caicos Islands'},
  {code: 'TV', name: 'Tuvalu'},
  {code: 'AED', name: 'UAE Dirham'},
  {code: 'UG', name: 'Uganda'},
  {code: 'UGX', name: 'Uganda Shilling'},
  {code: 'UA', name: 'Ukraine'},
  {code: 'CLF', name: 'Unidad de Fomento'},
  {code: 'COU', name: 'Unidad de Valor Real'},
  {code: 'UYW', name: 'Unidad Previsional'},
  {code: 'AE', name: 'United Arab Emirates'},
  {code: 'GB', name: 'United Kingdom'},
  {code: 'XI', name: 'United Kingdom (Northern Ireland)'},
  {code: 'US', name: 'United States'},
  {code: 'UM', name: 'United States Minor Outlying Island'},
  {code: 'UY', name: 'Uruguay'},
  {code: 'UYI', name: 'Uruguay Peso en Unidades Indexadas (UI)'},
  {code: 'USD', name: 'US Dollar'},
  {code: 'VI', name: 'US Virgin Islands'},
  {code: 'UZ', name: 'Uzbekistan'},
  {code: 'UZS', name: 'Uzbekistan Sum'},
  {code: 'VU', name: 'Vanuatu'},
  {code: 'VA', name: 'Vatican City'},
  {code: 'VUV', name: 'Vatu'},
  {code: 'VE', name: 'Venezuela'},
  {code: 'VN', name: 'Vietnam'},
  {code: 'WF', name: 'Wallis and Futuna Islands'},
  {code: 'XP', name: 'West Bank and Gaza Strip'},
  {code: 'EH', name: 'Western Sahara'},
  {code: 'CHE', name: 'WIR Euro'},
  {code: 'CHW', name: 'WIR Franc'},
  {code: 'KRW', name: 'Won'},
  {code: 'YE', name: 'Yemen'},
  {code: 'YER', name: 'Yemeni Rial'},
  {code: 'JPY', name: 'Yen'},
  {code: 'CNY', name: 'Yuan Renminbi'},
  {code: 'ZR', name: 'Zaire'},
  {code: 'ZM', name: 'Zambia'},
  {code: 'ZMW', name: 'Zambian Kwacha'},
  {code: 'ZW', name: 'Zimbabwe'},
  {code: 'ZWL', name: 'Zimbabwe Dollar'},
  {code: 'PLN', name: 'Zloty'}
];

export const COUNTRY_WITH_CODE_OPTIONS = COUNTRY_CODE_NAME.map((c) => ({
  value: c.code,
  label: `${c.name} - ${c.code}`
}));

export const COUNTRY_OPTIONS = [
  {value: 'Afghani', label: 'Afghani'},
  {value: 'Afghanistan', label: 'Afghanistan'},
  {value: 'ÅLAND ISLANDS', label: 'ÅLAND ISLANDS'},
  {value: 'Albania', label: 'Albania'},
  {value: 'Algeria', label: 'Algeria'},
  {value: 'Algerian Dinar', label: 'Algerian Dinar'},
  {value: 'American Oceania', label: 'American Oceania'},
  {value: 'American Samoa', label: 'American Samoa'},
  {value: 'Andorra', label: 'Andorra'},
  {value: 'Angola', label: 'Angola'},
  {value: 'Anguilla', label: 'Anguilla'},
  {value: 'Antigua and Barbuda', label: 'Antigua and Barbuda'},
  {value: 'Argentina', label: 'Argentina'},
  {value: 'Argentine Peso', label: 'Argentine Peso'},
  {value: 'Armenia', label: 'Armenia'},
  {value: 'Armenian Dram', label: 'Armenian Dram'},
  {value: 'Aruba', label: 'Aruba'},
  {value: 'Aruban Florin', label: 'Aruban Florin'},
  {value: 'Aruban Florin', label: 'Aruban Florin'},
  {value: 'Australia', label: 'Australia'},
  {value: 'Australian Dollar', label: 'Australian Dollar'},
  {value: 'Australian Oceania', label: 'Australian Oceania'},
  {value: 'Austria', label: 'Austria'},
  {value: 'Azerbaijan', label: 'Azerbaijan'},
  {value: 'Azerbaijan Manat', label: 'Azerbaijan Manat'},
  {value: 'Bahamas', label: 'Bahamas'},
  {value: 'Bahamian Dollar', label: 'Bahamian Dollar'},
  {value: 'Bahrain', label: 'Bahrain'},
  {value: 'Bahraini Dinar', label: 'Bahraini Dinar'},
  {value: 'Baht', label: 'Baht'},
  {value: 'Balboa', label: 'Balboa'},
  {value: 'Bangladesh', label: 'Bangladesh'},
  {value: 'Barbados', label: 'Barbados'},
  {value: 'Barbados Dollar', label: 'Barbados Dollar'},
  {value: 'Belarus', label: 'Belarus'},
  {value: 'Belarusian Ruble', label: 'Belarusian Ruble'},
  {value: 'Belgium', label: 'Belgium'},
  {value: 'Belize', label: 'Belize'},
  {value: 'Belize Dollar', label: 'Belize Dollar'},
  {value: 'Benin', label: 'Benin'},
  {value: 'Bermuda', label: 'Bermuda'},
  {value: 'Bermudian Dollar', label: 'Bermudian Dollar'},
  {value: 'Bhutan', label: 'Bhutan'},
  {value: 'Bolivar Soberano', label: 'Bolivar Soberano'},
  {value: 'Bolívar Soberano', label: 'Bolívar Soberano'},
  {
    value: 'Bolivia, Plurinational State of',
    label: 'Bolivia, Plurinational State of'
  },
  {value: 'Boliviano', label: 'Boliviano'},
  {
    value: 'Bonaire, Sint Eustatius and Saba',
    label: 'Bonaire, Sint Eustatius and Saba'
  },

  {value: 'Bosnia and Herzegovina', label: 'Bosnia and Herzegovina'},
  {value: 'Botswana', label: 'Botswana'},
  {value: 'Bouvet Island', label: 'Bouvet Island'},
  {value: 'Brazil', label: 'Brazil'},
  {value: 'Brazilian Real', label: 'Brazilian Real'},
  {
    value: 'British Indian Ocean Territory',
    label: 'British Indian Ocean Territory'
  },
  {value: 'British Virgin Islands', label: 'British Virgin Islands'},
  {value: 'Brunei Darussalam', label: 'Brunei Darussalam'},
  {value: 'Brunei Dollar', label: 'Brunei Dollar'},
  {value: 'Bulgaria', label: 'Bulgaria'},
  {value: 'Bulgarian Lev', label: 'Bulgarian Lev'},
  {value: 'Burkina Faso', label: 'Burkina Faso'},
  {value: 'Burundi', label: 'Burundi'},
  {value: 'Burundi Franc', label: 'Burundi Franc'},
  {value: 'Cabo Verde Escudo', label: 'Cabo Verde Escudo'},
  {value: 'Cambodia', label: 'Cambodia'},
  {value: 'Cameroon', label: 'Cameroon'},
  {value: 'Canada', label: 'Canada'},
  {value: 'Canadian Dollar', label: 'Canadian Dollar'},
  {value: 'Cape Verde', label: 'Cape Verde'},
  {value: 'Cayman Islands', label: 'Cayman Islands'},
  {value: 'Cayman Islands Dollar', label: 'Cayman Islands Dollar'},
  {value: 'Central African Republic', label: 'Central African Republic'},
  {value: 'Ceuta', label: 'Ceuta'},
  {value: 'CFA Franc BCEAO', label: 'CFA Franc BCEAO'},
  {value: 'CFA Franc BEAC', label: 'CFA Franc BEAC'},
  {value: 'CFP Franc', label: 'CFP Franc'},
  {value: 'Chad', label: 'Chad'},
  {value: 'Chile', label: 'Chile'},
  {value: 'Chilean Peso', label: 'Chilean Peso'},
  {value: 'China', label: 'China'},
  {value: 'Christmas Island', label: 'Christmas Island'},
  {
    value: 'Cocos Islands (or Keeling Islands)',
    label: 'Cocos Islands (or Keeling Islands)'
  },
  {value: 'Colombia', label: 'Colombia'},
  {value: 'Colombian Peso', label: 'Colombian Peso'},
  {value: 'Comorian Franc', label: 'Comorian Franc'},
  {value: 'Comoros', label: 'Comoros'},
  {value: 'Congo', label: 'Congo'},
  {
    value: 'Congo, Democratic Republic of',
    label: 'Congo, Democratic Republic of'
  },
  {value: 'Congolese Franc', label: 'Congolese Franc'},
  {value: 'Convertible Mark', label: 'Convertible Mark'},
  {value: 'Cook Islands', label: 'Cook Islands'},
  {value: 'Cordoba Oro', label: 'Cordoba Oro'},
  {value: 'Costa Rica', label: 'Costa Rica'},
  {value: 'Costa Rican Colon', label: 'Costa Rican Colon'},
  {value: 'Côte dIvoire', label: 'Côte dIvoire'},
  {value: 'Croatia', label: 'Croatia'},
  {value: 'Cuba', label: 'Cuba'},
  {value: 'Cuban Peso', label: 'Cuban Peso'},
  {value: 'Curaçao', label: 'Curaçao'},
  {value: 'Cyprus', label: 'Cyprus'},
  {value: 'Czech Koruna', label: 'Czech Koruna'},
  {value: 'Czechia', label: 'Czechia'},
  {value: 'Dalasi', label: 'Dalasi'},
  {value: 'Danish Krone', label: 'Danish Krone'},
  {value: 'Denar', label: 'Denar'},
  {value: 'Denmark', label: 'Denmark'},
  {value: 'Djibouti', label: 'Djibouti'},
  {value: 'Djibouti Franc', label: 'Djibouti Franc'},
  {value: 'Dobra', label: 'Dobra'},
  {value: 'Dominica', label: 'Dominica'},
  {value: 'Dominican Peso', label: 'Dominican Peso'},
  {value: 'Dominican Republic', label: 'Dominican Republic'},
  {value: 'Dong', label: 'Dong'},
  {value: 'East Caribbean Dollar', label: 'East Caribbean Dollar'},
  {value: 'East Timor', label: 'East Timor'},
  {value: 'Ecuador', label: 'Ecuador'},
  {value: 'Egypt', label: 'Egypt'},
  {value: 'Egyptian Pound', label: 'Egyptian Pound'},
  {value: 'El Salvador', label: 'El Salvador'},
  {value: 'El Salvador Colon', label: 'El Salvador Colon'},
  {value: 'Equatorial Guinea', label: 'Equatorial Guinea'},
  {value: 'Eritrea', label: 'Eritrea'},
  {value: 'Estonia', label: 'Estonia'},
  {value: 'Ethiopia', label: 'Ethiopia'},
  {value: 'Ethiopian Birr', label: 'Ethiopian Birr'},
  {value: 'Euro', label: 'Euro'},
  {value: 'European Community', label: 'European Community'},
  {value: 'Falkland Islands', label: 'Falkland Islands'},
  {value: 'Falkland Islands Pound', label: 'Falkland Islands Pound'},
  {value: 'Faroe Islands', label: 'Faroe Islands'},
  {
    value: 'Federal Republic of Yugoslavia',
    label: 'Federal Republic of Yugoslavia'
  },
  {value: 'Fiji', label: 'Fiji'},
  {value: 'Fiji Dollar', label: 'Fiji Dollar'},
  {value: 'Finland', label: 'Finland'},
  {value: 'Forint', label: 'Forint'},
  {value: 'France', label: 'France'},
  {value: 'French Guyana', label: 'French Guyana'},
  {value: 'French Polynesia', label: 'French Polynesia'},
  {value: 'French Southern Territories', label: 'French Southern Territories'},
  {value: 'Gabon', label: 'Gabon'},
  {value: 'Gambia', label: 'Gambia'},
  {value: 'Georgia', label: 'Georgia'},
  {value: 'Germany', label: 'Germany'},
  {value: 'Ghana', label: 'Ghana'},
  {value: 'Ghana Cedi', label: 'Ghana Cedi'},
  {value: 'Gibraltar', label: 'Gibraltar'},
  {value: 'Gibraltar Pound', label: 'Gibraltar Pound'},
  {value: 'Gourde', label: 'Gourde'},
  {value: 'Greece', label: 'Greece'},
  {value: 'Greenland', label: 'Greenland'},
  {value: 'Grenada', label: 'Grenada'},
  {value: 'Guadeloupe', label: 'Guadeloupe'},
  {value: 'Guam', label: 'Guam'},
  {value: 'Guarani', label: 'Guarani'},
  {value: 'Guatemala', label: 'Guatemala'},
  {value: 'Guernsey', label: 'Guernsey'},
  {value: 'Guinea', label: 'Guinea'},
  {value: 'Guinea-Bissau', label: 'Guinea-Bissau'},
  {value: 'Guinean Franc', label: 'Guinean Franc'},
  {value: 'Guyana', label: 'Guyana'},
  {value: 'Guyana Dollar', label: 'Guyana Dollar'},
  {value: 'Haiti', label: 'Haiti'},
  {
    value: 'Heard Island and McDonald Islands',
    label: 'Heard Island and McDonald Islands'
  },
  {value: 'High seas', label: 'High seas'},
  {value: 'Honduras', label: 'Honduras'},
  {value: 'Hong Kong', label: 'Hong Kong'},
  {value: 'Hong Kong Dollar', label: 'Hong Kong Dollar'},
  {value: 'Hryvnia', label: 'Hryvnia'},
  {value: 'Hungary', label: 'Hungary'},
  {value: 'Iceland', label: 'Iceland'},
  {value: 'Iceland Krona', label: 'Iceland Krona'},
  {value: 'India', label: 'India'},
  {value: 'Indian Rupee', label: 'Indian Rupee'},
  {value: 'Indonesia', label: 'Indonesia'},
  {value: 'Iran, Islamic Republic of', label: 'Iran, Islamic Republic of'},
  {value: 'Iranian Rial', label: 'Iranian Rial'},
  {value: 'Iraq', label: 'Iraq'},
  {value: 'Iraqi Dinar', label: 'Iraqi Dinar'},
  {value: 'Ireland', label: 'Ireland'},
  {value: 'Isle of Man', label: 'Isle of Man'},
  {value: 'Israel', label: 'Israel'},
  {value: 'Italy', label: 'Italy'},
  {value: 'Jamaica', label: 'Jamaica'},
  {value: 'Jamaican Dollar', label: 'Jamaican Dollar'},
  {value: 'Japan', label: 'Japan'},
  {value: 'Jersey', label: 'Jersey'},
  {value: 'Jordan', label: 'Jordan'},
  {value: 'Jordanian Dinar', label: 'Jordanian Dinar'},
  {value: 'Kazakhstan', label: 'Kazakhstan'},
  {value: 'Kenya', label: 'Kenya'},
  {value: 'Kenyan Shilling', label: 'Kenyan Shilling'},
  {value: 'Kina', label: 'Kina'},
  {value: 'Kiribati', label: 'Kiribati'},
  {
    value: 'Korea, Democratic People’s Republ',
    label: 'Korea, Democratic People’s Republ'
  },
  {value: 'Korea, Republic of', label: 'Korea, Republic of'},
  {value: 'Kosovo', label: 'Kosovo'},
  {value: 'Kuwait', label: 'Kuwait'},
  {value: 'Kuwaiti Dinar', label: 'Kuwaiti Dinar'},
  {value: 'Kwanza', label: 'Kwanza'},
  {value: 'Kyat', label: 'Kyat'},
  {value: 'Kyrgyz, Republic', label: 'Kyrgyz, Republic'},
  {value: 'Lao Kip', label: 'Lao Kip'},
  {
    value: 'Lao People’s Democratic Republic',
    label: 'Lao People’s Democratic Republic'
  },
  {value: 'Lari', label: 'Lari'},
  {value: 'Latvia', label: 'Latvia'},
  {value: 'Lebanese Pound', label: 'Lebanese Pound'},
  {value: 'Lebanon', label: 'Lebanon'},
  {value: 'Lek', label: 'Lek'},
  {value: 'Lempira', label: 'Lempira'},
  {value: 'Leone', label: 'Leone'},
  {value: 'Leone', label: 'Leone'},
  {value: 'Lesotho', label: 'Lesotho'},
  {value: 'Liberia', label: 'Liberia'},
  {value: 'Liberian Dollar', label: 'Liberian Dollar'},
  {value: 'Libya', label: 'Libya'},
  {value: 'Libyan Dinar', label: 'Libyan Dinar'},
  {value: 'Liechtenstein', label: 'Liechtenstein'},
  {value: 'Lilangeni', label: 'Lilangeni'},
  {value: 'Lithuania', label: 'Lithuania'},
  {value: 'Loti', label: 'Loti'},
  {value: 'Luxembourg', label: 'Luxembourg'},
  {value: 'Macao', label: 'Macao'},
  {value: 'Madagascar', label: 'Madagascar'},
  {value: 'Malagasy Ariary', label: 'Malagasy Ariary'},
  {value: 'Malawi', label: 'Malawi'},
  {value: 'Malawi Kwacha', label: 'Malawi Kwacha'},
  {value: 'Malaysia', label: 'Malaysia'},
  {value: 'Malaysian Ringgit', label: 'Malaysian Ringgit'},
  {value: 'Maldives', label: 'Maldives'},
  {value: 'Mali', label: 'Mali'},
  {value: 'Malta', label: 'Malta'},
  {value: 'Marshall Islands', label: 'Marshall Islands'},
  {value: 'Martinique', label: 'Martinique'},
  {value: 'Mauritania', label: 'Mauritania'},
  {value: 'Mauritius', label: 'Mauritius'},
  {value: 'Mauritius Rupee', label: 'Mauritius Rupee'},
  {value: 'Mayotte', label: 'Mayotte'},
  {value: 'Melilla', label: 'Melilla'},
  {value: 'Mexican Peso', label: 'Mexican Peso'},
  {
    value: 'Mexican Unidad de Inversion (UDI)',
    label: 'Mexican Unidad de Inversion (UDI)'
  },
  {value: 'Mexico', label: 'Mexico'},
  {
    value: 'Micronesia, Federated States of',
    label: 'Micronesia, Federated States of'
  },
  {value: 'Moldova, Republic of', label: 'Moldova, Republic of'},
  {value: 'Moldovan Leu', label: 'Moldovan Leu'},
  {value: 'Monaco', label: 'Monaco'},
  {value: 'Mongolia', label: 'Mongolia'},
  {value: 'Montenegro', label: 'Montenegro'},
  {value: 'Montenegro', label: 'Montenegro'},
  {value: 'Montserrat', label: 'Montserrat'},
  {value: 'Moroccan Dirham', label: 'Moroccan Dirham'},
  {value: 'Morocco', label: 'Morocco'},
  {value: 'Mozambique', label: 'Mozambique'},
  {value: 'Mozambique Metical', label: 'Mozambique Metical'},
  {value: 'Mvdol', label: 'Mvdol'},
  {value: 'Myanmar', label: 'Myanmar'},
  {value: 'Naira', label: 'Naira'},
  {value: 'Nakfa', label: 'Nakfa'},
  {value: 'Namibia', label: 'Namibia'},
  {value: 'Namibia Dollar', label: 'Namibia Dollar'},
  {value: 'Nauru', label: 'Nauru'},
  {value: 'Nepal', label: 'Nepal'},
  {value: 'Nepalese Rupee', label: 'Nepalese Rupee'},
  {value: 'Netherlands', label: 'Netherlands'},
  {
    value: 'Netherlands Antillean Guilder',
    label: 'Netherlands Antillean Guilder'
  },
  {value: 'Netherlands Antilles', label: 'Netherlands Antilles'},
  {value: 'New Caledonia', label: 'New Caledonia'},
  {value: 'New Israeli Sheqel', label: 'New Israeli Sheqel'},
  {value: 'New Taiwan Dollar', label: 'New Taiwan Dollar'},
  {value: 'New Zealand', label: 'New Zealand'},
  {value: 'New Zealand Dollar', label: 'New Zealand Dollar'},
  {value: 'New Zealand Oceania', label: 'New Zealand Oceania'},
  {value: 'Ngultrum', label: 'Ngultrum'},
  {value: 'Nicaragua', label: 'Nicaragua'},
  {value: 'Niger', label: 'Niger'},
  {value: 'Nigeria', label: 'Nigeria'},
  {value: 'Niue', label: 'Niue'},
  {value: 'Norfolk Island', label: 'Norfolk Island'},
  {value: 'North Korean Won', label: 'North Korean Won'},
  {value: 'North Macedonia', label: 'North Macedonia'},
  {value: 'Northern Mariana Islands', label: 'Northern Mariana Islands'},
  {value: 'Norway', label: 'Norway'},
  {value: 'Norwegian Krone', label: 'Norwegian Krone'},
  {
    value: 'Occupied Palestinian Territory',
    label: 'Occupied Palestinian Territory'
  },
  {value: 'Oman', label: 'Oman'},
  {value: 'Ouguiya', label: 'Ouguiya'},
  {value: 'Pa’anga', label: 'Pa’anga'},
  {value: 'Pakistan', label: 'Pakistan'},
  {value: 'Pakistan Rupee', label: 'Pakistan Rupee'},
  {value: 'Palau', label: 'Palau'},
  {value: 'Panama', label: 'Panama'},
  {value: 'Papua New Guinea', label: 'Papua New Guinea'},
  {value: 'Paraguay', label: 'Paraguay'},
  {value: 'Pataca', label: 'Pataca'},
  {value: 'Peru', label: 'Peru'},
  {value: 'Peso Convertible', label: 'Peso Convertible'},
  {value: 'Peso Uruguayo', label: 'Peso Uruguayo'},
  {value: 'Philippine Peso', label: 'Philippine Peso'},
  {value: 'Philippines', label: 'Philippines'},
  {value: 'Pitcairn', label: 'Pitcairn'},
  {value: 'Poland', label: 'Poland'},
  {value: 'Polar regions', label: 'Polar regions'},
  {value: 'Portugal', label: 'Portugal'},
  {value: 'Pound Sterling', label: 'Pound Sterling'},
  {value: 'Puerto Rico', label: 'Puerto Rico'},
  {value: 'Pula', label: 'Pula'},
  {value: 'Qatar', label: 'Qatar'},
  {value: 'Qatari Rial', label: 'Qatari Rial'},
  {value: 'Quetzal', label: 'Quetzal'},
  {value: 'Rand', label: 'Rand'},
  {value: 'Réunion', label: 'Réunion'},
  {value: 'Rial Omani', label: 'Rial Omani'},
  {value: 'Riel', label: 'Riel'},
  {value: 'Romania', label: 'Romania'},
  {value: 'Romanian Leu', label: 'Romanian Leu'},
  {value: 'Rufiyaa', label: 'Rufiyaa'},
  {value: 'Rupiah', label: 'Rupiah'},
  {value: 'Russian Federation', label: 'Russian Federation'},
  {value: 'Russian Ruble', label: 'Russian Ruble'},
  {value: 'Rwanda', label: 'Rwanda'},
  {value: 'Rwanda Franc', label: 'Rwanda Franc'},
  {value: 'Saint Barthélemy', label: 'Saint Barthélemy'},
  {value: 'Saint Helena Pound', label: 'Saint Helena Pound'},
  {
    value: 'Saint Helena, Ascension and Tristan',
    label: 'Saint Helena, Ascension and Tristan'
  },
  {value: 'Saint Martin (French part)', label: 'Saint Martin (French part)'},
  {value: 'Samoa', label: 'Samoa'},
  {value: 'San Marino', label: 'San Marino'},
  {value: 'Sao Tome and Principe', label: 'Sao Tome and Principe'},
  {value: 'Saudi Arabia', label: 'Saudi Arabia'},
  {value: 'Saudi Riyal', label: 'Saudi Riyal'},
  {value: 'SDR (Special Drawing Right)', label: 'SDR (Special Drawing Right)'},
  {value: 'Senegal', label: 'Senegal'},
  {value: 'Serbia', label: 'Serbia'},
  {value: 'Serbia', label: 'Serbia'},
  {value: 'Serbian Dinar', label: 'Serbian Dinar'},
  {value: 'Seychelles', label: 'Seychelles'},
  {value: 'Seychelles Rupee', label: 'Seychelles Rupee'},
  {value: 'Sierra Leone', label: 'Sierra Leone'},
  {value: 'Singapore', label: 'Singapore'},
  {value: 'Singapore Dollar', label: 'Singapore Dollar'},
  {value: 'Sint Maarten (Dutch part)', label: 'Sint Maarten (Dutch part)'},
  {value: 'Slovakia', label: 'Slovakia'},
  {value: 'Slovenia', label: 'Slovenia'},
  {value: 'Sol', label: 'Sol'},
  {value: 'Solomon Islands', label: 'Solomon Islands'},
  {value: 'Solomon Islands Dollar', label: 'Solomon Islands Dollar'},
  {value: 'Som', label: 'Som'},
  {value: 'Somali Shilling', label: 'Somali Shilling'},
  {value: 'Somalia', label: 'Somalia'},
  {value: 'Somoni', label: 'Somoni'},
  {value: 'South Africa', label: 'South Africa'},
  {
    value: 'South Georgia and South Sandwich',
    label: 'South Georgia and South Sandwich'
  },
  {value: 'South Sudan', label: 'South Sudan'},
  {value: 'South Sudanese Pound', label: 'South Sudanese Pound'},
  {value: 'Spain', label: 'Spain'},
  {value: 'Sri Lanka', label: 'Sri Lanka'},
  {value: 'Sri Lanka Rupee', label: 'Sri Lanka Rupee'},
  {value: 'St Kitts and Nevis', label: 'St Kitts and Nevis'},
  {value: 'St Lucia', label: 'St Lucia'},
  {value: 'St Pierre and Miquelon', label: 'St Pierre and Miquelon'},
  {value: 'St Vincent', label: 'St Vincent'},
  {value: 'Sudan', label: 'Sudan'},
  {value: 'Sudanese Pound', label: 'Sudanese Pound'},
  {value: 'Surinam Dollar', label: 'Surinam Dollar'},
  {value: 'Suriname', label: 'Suriname'},
  {
    value: 'Svalbard and Jan Mayen Islands',
    label: 'Svalbard and Jan Mayen Islands'
  },
  {value: 'Swaziland', label: 'Swaziland'},
  {value: 'Sweden', label: 'Sweden'},
  {value: 'Swedish Krona', label: 'Swedish Krona'},
  {value: 'Swiss Franc', label: 'Swiss Franc'},
  {value: 'Switzerland', label: 'Switzerland'},
  {value: 'Syrian Arab Republic', label: 'Syrian Arab Republic'},
  {value: 'Syrian Pound', label: 'Syrian Pound'},
  {value: 'Taiwan', label: 'Taiwan'},
  {value: 'Tajikistan', label: 'Tajikistan'},
  {value: 'Taka', label: 'Taka'},
  {value: 'Tala', label: 'Tala'},
  {
    value: 'Tanzania, United Republic of',
    label: 'Tanzania, United Republic of'
  },
  {value: 'Tanzanian Shilling', label: 'Tanzanian Shilling'},
  {value: 'Tenge', label: 'Tenge'},
  {value: 'Thailand', label: 'Thailand'},
  {value: 'Timor-Leste', label: 'Timor-Leste'},
  {value: 'Togo', label: 'Togo'},
  {value: 'Tokelau', label: 'Tokelau'},
  {value: 'Tonga', label: 'Tonga'},
  {value: 'Trinidad and Tobago', label: 'Trinidad and Tobago'},
  {value: 'Trinidad and Tobago Dollar', label: 'Trinidad and Tobago Dollar'},
  {value: 'Tugrik', label: 'Tugrik'},
  {value: 'Tunisia', label: 'Tunisia'},
  {value: 'Tunisian Dinar', label: 'Tunisian Dinar'},
  {value: 'Turkish Lira', label: 'Turkish Lira'},
  {value: 'Türkiye', label: 'Türkiye'},
  {value: 'Turkmenistan', label: 'Turkmenistan'},
  {value: 'Turkmenistan New Manat', label: 'Turkmenistan New Manat'},
  {value: 'Turks and Caicos Islands', label: 'Turks and Caicos Islands'},
  {value: 'Tuvalu', label: 'Tuvalu'},
  {value: 'UAE Dirham', label: 'UAE Dirham'},
  {value: 'Uganda', label: 'Uganda'},
  {value: 'Uganda Shilling', label: 'Uganda Shilling'},
  {value: 'Ukraine', label: 'Ukraine'},
  {value: 'Unidad de Fomento', label: 'Unidad de Fomento'},
  {value: 'Unidad de Valor Real', label: 'Unidad de Valor Real'},
  {value: 'Unidad Previsional', label: 'Unidad Previsional'},
  {value: 'United Arab Emirates', label: 'United Arab Emirates'},
  {value: 'United Kingdom', label: 'United Kingdom'},
  {
    value: 'United Kingdom (Northern Ireland)',
    label: 'United Kingdom (Northern Ireland)'
  },
  {value: 'United States', label: 'United States'},
  {
    value: 'United States Minor Outlying Island',
    label: 'United States Minor Outlying Island'
  },
  {value: 'Uruguay', label: 'Uruguay'},
  {
    value: 'Uruguay Peso en Unidades Indexadas (UI)',
    label: 'Uruguay Peso en Unidades Indexadas (UI)'
  },
  {value: 'US Dollar', label: 'US Dollar'},
  {value: 'US Virgin Islands', label: 'US Virgin Islands'},
  {value: 'Uzbekistan', label: 'Uzbekistan'},
  {value: 'Uzbekistan Sum', label: 'Uzbekistan Sum'},
  {value: 'Vanuatu', label: 'Vanuatu'},
  {value: 'Vatican City', label: 'Vatican City'},
  {value: 'Vatu', label: 'Vatu'},
  {value: 'Venezuela', label: 'Venezuela'},
  {value: 'Vietnam', label: 'Vietnam'},
  {value: 'Wallis and Futuna Islands', label: 'Wallis and Futuna Islands'},
  {value: 'West Bank and Gaza Strip', label: 'West Bank and Gaza Strip'},
  {value: 'Western Sahara', label: 'Western Sahara'},
  {value: 'WIR Euro', label: 'WIR Euro'},
  {value: 'WIR Franc', label: 'WIR Franc'},
  {value: 'Won', label: 'Won'},
  {value: 'Yemen', label: 'Yemen'},
  {value: 'Yemeni Rial', label: 'Yemeni Rial'},
  {value: 'Yen', label: 'Yen'},
  {value: 'Yuan Renminbi', label: 'Yuan Renminbi'},
  {value: 'Zaire', label: 'Zaire'},
  {value: 'Zambia', label: 'Zambia'},
  {value: 'Zambian Kwacha', label: 'Zambian Kwacha'},
  {value: 'Zimbabwe', label: 'Zimbabwe'},
  {value: 'Zimbabwe Dollar', label: 'Zimbabwe Dollar'},
  {value: 'Zloty', label: 'Zloty'}
];

export const ECONOMIC_ACTIVITY_OPTIONS = [
  {
    value:
      '1.11 - Growing of cereals, other than rice, leguminous crops and oil seeds',
    label:
      '1.11 - Growing of cereals, other than rice, leguminous crops and oil seeds'
  },
  {value: '1.12 - Growing of rice', label: '1.12 - Growing of rice'},
  {
    value: '1.13 - Growing of vegetables and melons, roots and tubers',
    label: '1.13 - Growing of vegetables and melons, roots and tubers'
  },
  {
    value: '1.14 - Growing of sugar cane',
    label: '1.14 - Growing of sugar cane'
  },
  {value: '1.15 - Growing of tobacco', label: '1.15 - Growing of tobacco'},
  {
    value: '1.16 - Growing of fibre crops',
    label: '1.16 - Growing of fibre crops'
  },
  {
    value: '1.19 - Growing of other non-perennial crops',
    label: '1.19 - Growing of other non-perennial crops'
  },
  {value: '1.21 - Growing of grapes', label: '1.21 - Growing of grapes'},
  {
    value: '1.22 - Growing of tropical and subtropical fruits',
    label: '1.22 - Growing of tropical and subtropical fruits'
  },
  {
    value: '1.23 - Growing of citrus fruits',
    label: '1.23 - Growing of citrus fruits'
  },
  {
    value: '1.24 - Growing of pome fruits and stone fruits',
    label: '1.24 - Growing of pome fruits and stone fruits'
  },
  {
    value: '1.25 - Growing of other tree and bush fruits and nuts',
    label: '1.25 - Growing of other tree and bush fruits and nuts'
  },
  {
    value: '1.26 - Growing of oleaginous fruits',
    label: '1.26 - Growing of oleaginous fruits'
  },
  {
    value: '1.27 - Growing of beverage crops',
    label: '1.27 - Growing of beverage crops'
  },
  {
    value: '1.28 - Growing of spices, aromatic, drug and pharmaceutical crops',
    label: '1.28 - Growing of spices, aromatic, drug and pharmaceutical crops'
  },
  {
    value: '1.29 - Growing of other perennial crops',
    label: '1.29 - Growing of other perennial crops'
  },
  {value: '1.3 - Plant propagation', label: '1.3 - Plant propagation'},
  {
    value: '1.41 - Raising of dairy cattle',
    label: '1.41 - Raising of dairy cattle'
  },
  {
    value: '1.42 - Raising of other cattle and buffaloes',
    label: '1.42 - Raising of other cattle and buffaloes'
  },
  {
    value: '42.13 - Construction of bridges and tunnels',
    label: '42.13 - Construction of bridges and tunnels'
  },
  {
    value: '42.21 - Construction of utility projects for fluids',
    label: '42.21 - Construction of utility projects for fluids'
  },
  {
    value:
      '42.22 - Construction of utility projects for electricity and telecommunications',
    label:
      '42.22 - Construction of utility projects for electricity and telecommunications'
  },
  {
    value: '42.91 - Construction of water projects',
    label: '42.91 - Construction of water projects'
  },
  {
    value: '42.99 - Construction of other civil engineering projects n.e.c.',
    label: '42.99 - Construction of other civil engineering projects n.e.c.'
  },
  {value: '43.11 - Demolition', label: '43.11 - Demolition'},
  {value: '43.12 - Site preparation', label: '43.12 - Site preparation'},
  {
    value: '43.13 - Test drilling and boring',
    label: '43.13 - Test drilling and boring'
  },
  {
    value: '43.21 - Electrical installation',
    label: '43.21 - Electrical installation'
  },
  {
    value: '43.22 - Plumbing, heat and air-conditioning installation',
    label: '43.22 - Plumbing, heat and air-conditioning installation'
  },
  {
    value: '43.23 - Installation of insulation',
    label: '43.23 - Installation of insulation'
  },
  {
    value: '43.24 - Other construction installation',
    label: '43.24 - Other construction installation'
  },
  {value: '43.31 - Plastering', label: '43.31 - Plastering'},

  {
    value: '43.32 - Joinery installation',
    label: '43.32 - Joinery installation'
  },
  {
    value: '43.33 - Floor and wall covering',
    label: '43.33 - Floor and wall covering'
  },
  {
    value: '43.34 - Painting and glazing',
    label: '43.34 - Painting and glazing'
  },
  {
    value: '43.35 - Other building completion and finishing',
    label: '43.35 - Other building completion and finishing'
  },
  {value: '43.41 - Roofing activities', label: '43.41 - Roofing activities'},
  {
    value:
      '43.42 - Other specialised construction activities in construction of buildings',
    label:
      '43.42 - Other specialised construction activities in construction of buildings'
  },
  {
    value: '43.5 - Specialised construction activities',
    label: '43.5 - Specialised construction activities'
  },
  {
    value:
      '46.11 - Activities of agents involved in the wholesale of agricultural raw materials, live animals, textile raw materials and semi-finished goods',
    label:
      '46.11 - Activities of agents involved in the wholesale of agricultural raw materials, live animals, textile raw materials and semi-finished goods'
  },
  {
    value:
      '46.12 - Activities of agents involved in the wholesale of fuels, ores, metals and industrial chemicals',
    label:
      '46.12 - Activities of agents involved in the wholesale of fuels, ores, metals and industrial chemicals'
  },
  {
    value:
      '46.13 - Activities of agents involved in the wholesale of timber and building materials',
    label:
      '46.13 - Activities of agents involved in the wholesale of timber and building materials'
  },
  {
    value:
      '46.14 - Activities of agents involved in the wholesale of machinery, industrial equipment, ships and aircraft',
    label:
      '46.14 - Activities of agents involved in the wholesale of machinery, industrial equipment, ships and aircraft'
  },
  {
    value:
      '46.15 - Activities of agents involved in the wholesale of furniture, household goods, hardware and ironmongery',
    label:
      '46.15 - Activities of agents involved in the wholesale of furniture, household goods, hardware and ironmongery'
  },
  {
    value:
      '46.16 - Activities of agents involved in the wholesale of textiles, clothing, fur, footwear and leather goods',
    label:
      '46.16 - Activities of agents involved in the wholesale of textiles, clothing, fur, footwear and leather goods'
  },
  {
    value:
      '46.17 - Activities of agents involved in the wholesale of food, beverages and tobacco',
    label:
      '46.17 - Activities of agents involved in the wholesale of food, beverages and tobacco'
  },
  {
    value:
      '46.18 - Activities of agents involved in the wholesale of other particular products',
    label:
      '46.18 - Activities of agents involved in the wholesale of other particular products'
  },
  {
    value: '46.19 - Activities of agents involved in non-specialised wholesale',
    label: '46.19 - Activities of agents involved in non-specialised wholesale'
  },
  {
    value:
      '46.21 - Wholesale of grain, unmanufactured tobacco, seeds and animal feeds',
    label:
      '46.21 - Wholesale of grain, unmanufactured tobacco, seeds and animal feeds'
  },
  {
    value: '46.22 - Wholesale of flowers and plants',
    label: '46.22 - Wholesale of flowers and plants'
  },
  {
    value: '46.23 - Wholesale of live animals',
    label: '46.23 - Wholesale of live animals'
  },
  {
    value: '46.24 - Wholesale of raw hides and skins and leather',
    label: '46.24 - Wholesale of raw hides and skins and leather'
  },
  {
    value: '46.31 - Wholesale of fruit and vegetables',
    label: '46.31 - Wholesale of fruit and vegetables'
  },
  {
    value: '46.32 - Wholesale of meat and meat products',
    label: '46.32 - Wholesale of meat and meat products'
  },
  {
    value: '46.33 - Wholesale of dairy products, eggs and edible oils and fats',
    label: '46.33 - Wholesale of dairy products, eggs and edible oils and fats'
  },
  {
    value: '46.34 - Wholesale of beverages',
    label: '46.34 - Wholesale of beverages'
  },
  {
    value: '46.35 - Wholesale of tobacco products',
    label: '46.35 - Wholesale of tobacco products'
  },
  {
    value: '46.36 - Wholesale of sugar, chocolate and sugar confectionery',
    label: '46.36 - Wholesale of sugar, chocolate and sugar confectionery'
  },
  {
    value: '46.37 - Wholesale of coffee, tea, cocoa and spices',
    label: '46.37 - Wholesale of coffee, tea, cocoa and spices'
  },
  {
    value:
      '46.38 - Wholesale of other food, including fish, crustaceans and molluscs',
    label:
      '46.38 - Wholesale of other food, including fish, crustaceans and molluscs'
  },
  {
    value: '46.39 - Non-specialised wholesale of food, beverages and tobacco',
    label: '46.39 - Non-specialised wholesale of food, beverages and tobacco'
  },
  {
    value: '49.11 - Passenger heavy rail transport',
    label: '49.11 - Passenger heavy rail transport'
  },
  {
    value: '49.12 - Other passenger rail transport',
    label: '49.12 - Other passenger rail transport'
  },
  {
    value: '49.2 - Freight rail transport',
    label: '49.2 - Freight rail transport'
  },
  {
    value: '49.31 - Scheduled passenger transport by road',
    label: '49.31 - Scheduled passenger transport by road'
  },
  {
    value: '49.32 - Non-scheduled passenger transport by road',
    label: '49.32 - Non-scheduled passenger transport by road'
  },
  {
    value:
      '49.33 - On-demand passenger transport service activities by vehicle with driver',
    label:
      '49.33 - On-demand passenger transport service activities by vehicle with driver'
  },
  {
    value: '49.34 - Passenger transport by cableways and ski lifts',
    label: '49.34 - Passenger transport by cableways and ski lifts'
  },
  {
    value: '49.39 - Other passenger land transport n.e.c.',
    label: '49.39 - Other passenger land transport n.e.c.'
  },
  {
    value: '49.41 - Freight transport by road',
    label: '49.41 - Freight transport by road'
  },
  {value: '49.42 - Removal services', label: '49.42 - Removal services'},
  {
    value: '49.5 - Transport via pipeline',
    label: '49.5 - Transport via pipeline'
  },
  {
    value: '50.1 - Sea and coastal passenger water transport',
    label: '50.1 - Sea and coastal passenger water transport'
  },
  {
    value: '50.2 - Sea and coastal freight water transport',
    label: '50.2 - Sea and coastal freight water transport'
  },
  {
    value: '50.3 - Inland passenger water transport',
    label: '50.3 - Inland passenger water transport'
  },
  {
    value: '50.4 - Inland freight water transport',
    label: '50.4 - Inland freight water transport'
  },
  {
    value: '51.1 - Passenger air transport',
    label: '51.1 - Passenger air transport'
  },
  {
    value: '51.21 - Freight air transport',
    label: '51.21 - Freight air transport'
  },
  {value: '51.22 - Space transport', label: '51.22 - Space transport'},
  {
    value: '52.1 - Warehousing and storage',
    label: '52.1 - Warehousing and storage'
  },
  {
    value: '52.21 - Service activities incidental to land transportation',
    label: '52.21 - Service activities incidental to land transportation'
  },
  {
    value: '52.22 - Service activities incidental to water transportation',
    label: '52.22 - Service activities incidental to water transportation'
  },
  {
    value: '52.23 - Service activities incidental to air transportation',
    label: '52.23 - Service activities incidental to air transportation'
  },
  {value: '52.24 - Cargo handling', label: '52.24 - Cargo handling'},
  {value: '52.25 - Logistics', label: '52.25 - Logistics'},
  {
    value: '55.1 - Hotels and similar accommodation',
    label: '55.1 - Hotels and similar accommodation'
  },
  {
    value: '55.2 - Holiday and other short-stay accommodation',
    label: '55.2 - Holiday and other short-stay accommodation'
  },
  {
    value: '55.3 - Camping grounds and recreational vehicle parks',
    label: '55.3 - Camping grounds and recreational vehicle parks'
  },
  {
    value: '55.4 - Intermediation service activities for accommodation',
    label: '55.4 - Intermediation service activities for accommodation'
  },
  {value: '55.9 - Other accommodation', label: '55.9 - Other accommodation'},
  {
    value: '56.11 - Restaurant activities',
    label: '56.11 - Restaurant activities'
  },
  {
    value: '56.12 - Mobile food service activities',
    label: '56.12 - Mobile food service activities'
  },
  {
    value: '56.21 - Event catering activities',
    label: '56.21 - Event catering activities'
  },
  {
    value:
      '56.22 - Contract catering service activities and other food service activities',
    label:
      '56.22 - Contract catering service activities and other food service activities'
  },
  {
    value: '56.3 - Beverage serving activities',
    label: '56.3 - Beverage serving activities'
  },
  {
    value:
      '56.4 - Intermediation service activities for food and beverage services activities',
    label:
      '56.4 - Intermediation service activities for food and beverage services activities'
  },
  {
    value: '58.11 - Publishing of books',
    label: '58.11 - Publishing of books'
  },
  {
    value: '58.12 - Publishing of newspapers',
    label: '58.12 - Publishing of newspapers'
  },
  {
    value: '58.13 - Publishing of journals and periodicals',
    label: '58.13 - Publishing of journals and periodicals'
  },
  {
    value: '58.19 - Other publishing activities, except software publishing',
    label: '58.19 - Other publishing activities, except software publishing'
  },
  {
    value: '58.21 - Publishing of video games',
    label: '58.21 - Publishing of video games'
  },
  {
    value: '58.29 - Other software publishing',
    label: '58.29 - Other software publishing'
  },
  {
    value:
      '59.11 - Motion picture, video and television programme production activities',
    label:
      '59.11 - Motion picture, video and television programme production activities'
  },
  {
    value:
      '59.12 - Motion picture, video and television programme post-production activities',
    label:
      '59.12 - Motion picture, video and television programme post-production activities'
  },
  {
    value: '59.13 - Motion picture and video distribution activities',
    label: '59.13 - Motion picture and video distribution activities'
  },
  {
    value: '59.14 - Motion picture projection activities',
    label: '59.14 - Motion picture projection activities'
  },
  {
    value: '59.2 - Sound recording and music publishing activities',
    label: '59.2 - Sound recording and music publishing activities'
  },
  {
    value: '60.1 - Radio broadcasting and audio distribution activities',
    label: '60.1 - Radio broadcasting and audio distribution activities'
  },
  {
    value:
      '60.2 - Television programming, broadcasting and video distribution activities',
    label:
      '60.2 - Television programming, broadcasting and video distribution activities'
  },
  {
    value: '60.31 - News agency activities',
    label: '60.31 - News agency activities'
  },
  {
    value: '60.39 - Other content distribution activities',
    label: '60.39 - Other content distribution activities'
  },
  {
    value: '61.1 - Wired, wireless, and satellite telecommunication activities',
    label: '61.1 - Wired, wireless, and satellite telecommunication activities'
  },
  {
    value:
      '61.2 - Telecommunication reselling activities and intermediation service activities for telecommunication',
    label:
      '61.2 - Telecommunication reselling activities and intermediation service activities for telecommunication'
  },
  {
    value: '61.9 - Other telecommunication activities',
    label: '61.9 - Other telecommunication activities'
  },
  {
    value: '62.1 - Computer programming activities',
    label: '62.1 - Computer programming activities'
  },
  {
    value:
      '62.2 - Computer consultancy and computer facilities management activities',
    label:
      '62.2 - Computer consultancy and computer facilities management activities'
  },
  {
    value:
      '62.9 - Other information technology and computer service activities',
    label: '62.9 - Other information technology and computer service activities'
  },
  {
    value:
      '63.1 - Computing infrastructure, data processing, hosting and related activities',
    label:
      '63.1 - Computing infrastructure, data processing, hosting and related activities'
  },
  {
    value: '63.91 - Web search portal activities',
    label: '63.91 - Web search portal activities'
  },
  {
    value: '63.92 - Other information service activities',
    label: '63.92 - Other information service activities'
  },
  {value: '64.11 - Central banking', label: '64.11 - Central banking'},
  {
    value: '64.19 - Other monetary intermediation',
    label: '64.19 - Other monetary intermediation'
  },
  {
    value: '64.21 - Activities of holding companies',
    label: '64.21 - Activities of holding companies'
  },
  {
    value: '64.22 - Activities of financing conduits',
    label: '64.22 - Activities of financing conduits'
  },
  {
    value:
      '64.31 - Activities of money market and non-money market investments funds',
    label:
      '64.31 - Activities of money market and non-money market investments funds'
  },
  {
    value: '64.32 - Activities of trust, estate and agency accounts',
    label: '64.32 - Activities of trust, estate and agency accounts'
  },
  {value: '64.91 - Financial leasing', label: '64.91 - Financial leasing'},
  {
    value: '64.92 - Other credit granting',
    label: '64.92 - Other credit granting'
  },
  {
    value:
      '64.99 - Other financial service activities, except insurance and pension funding n.e.c.',
    label:
      '64.99 - Other financial service activities, except insurance and pension funding n.e.c.'
  },
  {value: '65.11 - Life insurance', label: '65.11 - Life insurance'},
  {
    value: '65.12 - Non-life insurance',
    label: '65.12 - Non-life insurance'
  },
  {value: '65.2 - Reinsurance', label: '65.2 - Reinsurance'},
  {value: '65.3 - Pension funding', label: '65.3 - Pension funding'},
  {
    value: '66.11 - Administration of financial markets',
    label: '66.11 - Administration of financial markets'
  },
  {
    value: '66.12 - Security and commodity contracts brokerage',
    label: '66.12 - Security and commodity contracts brokerage'
  },
  {
    value:
      '66.19 - Other activities auxiliary to financial services, except insurance and pension funding',
    label:
      '66.19 - Other activities auxiliary to financial services, except insurance and pension funding'
  },
  {
    value: '66.21 - Risk and damage evaluation',
    label: '66.21 - Risk and damage evaluation'
  },
  {
    value: '66.22 - Activities of insurance agents and brokers',
    label: '66.22 - Activities of insurance agents and brokers'
  },
  {
    value:
      '66.29 - Activities auxiliary to insurance and pension funding n.e.c.',
    label:
      '66.29 - Activities auxiliary to insurance and pension funding n.e.c.'
  },
  {
    value: '66.3 - Fund management activities',
    label: '66.3 - Fund management activities'
  },
  {
    value: '68.11 - Buying and selling of own real estate',
    label: '68.11 - Buying and selling of own real estate'
  },
  {
    value: '68.12 - Development of building projects',
    label: '68.12 - Development of building projects'
  },
  {
    value: '68.2 - Rental and operating of own or leased real estate',
    label: '68.2 - Rental and operating of own or leased real estate'
  },
  {
    value:
      '68.31 - Intermediation service activities for real estate activities',
    label:
      '68.31 - Intermediation service activities for real estate activities'
  },
  {
    value: '68.32 - Other real estate activities on a fee or contract basis',
    label: '68.32 - Other real estate activities on a fee or contract basis'
  },
  {value: '69.1 - Legal activities', label: '69.1 - Legal activities'},
  {
    value:
      '69.2 - Accounting, bookkeeping and auditing activities; tax consultancy',
    label:
      '69.2 - Accounting, bookkeeping and auditing activities; tax consultancy'
  },
  {
    value: '70.1 - Activities of head offices',
    label: '70.1 - Activities of head offices'
  },
  {
    value: '70.2 - Business and other management consultancy activities',
    label: '70.2 - Business and other management consultancy activities'
  },
  {
    value: '71.11 - Architectural activities',
    label: '71.11 - Architectural activities'
  },
  {
    value: '71.12 - Engineering activities and related technical consultancy',
    label: '71.12 - Engineering activities and related technical consultancy'
  },
  {
    value: '71.2 - Technical testing and analysis',
    label: '71.2 - Technical testing and analysis'
  },
  {
    value:
      '72.1 - Research and experimental development on natural sciences and engineering',
    label:
      '72.1 - Research and experimental development on natural sciences and engineering'
  },
  {
    value:
      '72.2 - Research and experimental development on social sciences and humanities',
    label:
      '72.2 - Research and experimental development on social sciences and humanities'
  },
  {
    value: '73.11 - Activities of advertising agencies',
    label: '73.11 - Activities of advertising agencies'
  },
  {
    value: '73.12 - Media representation',
    label: '73.12 - Media representation'
  },
  {
    value: '73.2 - Market research and public opinion polling',
    label: '73.2 - Market research and public opinion polling'
  },
  {
    value: '73.3 - Public relations and communication activities',
    label: '73.3 - Public relations and communication activities'
  },
  {
    value: '74.11 - Industrial product and fashion design activities',
    label: '74.11 - Industrial product and fashion design activities'
  },
  {
    value: '74.12 - Graphic design and visual communication activities',
    label: '74.12 - Graphic design and visual communication activities'
  },
  {
    value: '74.13 - Interior design activities',
    label: '74.13 - Interior design activities'
  },
  {
    value: '74.14 - Other specialised design activities',
    label: '74.14 - Other specialised design activities'
  },
  {
    value: '74.2 - Photographic activities',
    label: '74.2 - Photographic activities'
  },
  {
    value: '74.3 - Translation and interpretation activities',
    label: '74.3 - Translation and interpretation activities'
  },
  {
    value: '74.91 - Patent brokering and marketing services',
    label: '74.91 - Patent brokering and marketing services'
  },
  {
    value: '77.11 - Rental and leasing of cars and light motor vehicles',
    label: '77.11 - Rental and leasing of cars and light motor vehicles'
  },
  {
    value: '77.12 - Rental and leasing of trucks',
    label: '77.12 - Rental and leasing of trucks'
  },
  {
    value: '77.21 - Rental and leasing of recreational and sports goods',
    label: '77.21 - Rental and leasing of recreational and sports goods'
  },
  {
    value: '77.22 - Rental and leasing of other personal and household goods',
    label: '77.22 - Rental and leasing of other personal and household goods'
  },
  {
    value: '77.31 - Rental and leasing of agricultural machinery and equipment',
    label: '77.31 - Rental and leasing of agricultural machinery and equipment'
  },
  {
    value:
      '77.32 - Rental and leasing of construction and civil engineering machinery and equipment',
    label:
      '77.32 - Rental and leasing of construction and civil engineering machinery and equipment'
  },
  {
    value:
      '77.33 - Rental and leasing of office machinery, equipment and computers',
    label:
      '77.33 - Rental and leasing of office machinery, equipment and computers'
  },
  {
    value: '77.34 - Rental and leasing of water transport equipment',
    label: '77.34 - Rental and leasing of water transport equipment'
  },
  {
    value: '77.35 - Rental and leasing of air transport equipment',
    label: '77.35 - Rental and leasing of air transport equipment'
  },
  {
    value:
      '77.39 - Rental and leasing of other machinery, equipment and tangible goods n.e.c.',
    label:
      '77.39 - Rental and leasing of other machinery, equipment and tangible goods n.e.c.'
  },
  {
    value:
      '77.4 - Leasing of intellectual property and similar products, except copyrighted works',
    label:
      '77.4 - Leasing of intellectual property and similar products, except copyrighted works'
  },
  {
    value:
      '77.51 - Intermediation service activities for rental and leasing of cars, motorhomes and trailers',
    label:
      '77.51 - Intermediation service activities for rental and leasing of cars, motorhomes and trailers'
  },
  {
    value:
      '77.52 - Intermediation service activities for rental and leasing of other tangible goods and non-financial intangible assets',
    label:
      '77.52 - Intermediation service activities for rental and leasing of other tangible goods and non-financial intangible assets'
  },
  {
    value: '78.1 - Activities of employment',
    label: '78.1 - Activities of employment'
  },
  {
    value: '84.11 - General public administration activities',
    label: '84.11 - General public administration activities'
  },
  {
    value:
      '84.12 - Regulation of health care, education, cultural services and other social services',
    label:
      '84.12 - Regulation of health care, education, cultural services and other social services'
  },
  {
    value:
      '84.13 - Regulation of and contribution to more efficient operation of businesses',
    label:
      '84.13 - Regulation of and contribution to more efficient operation of businesses'
  },
  {value: '84.21 - Foreign affairs', label: '84.21 - Foreign affairs'},
  {
    value: '84.22 - Defence activities',
    label: '84.22 - Defence activities'
  },
  {
    value: '84.23 - Justice and judicial activities',
    label: '84.23 - Justice and judicial activities'
  },
  {
    value: '84.24 - Public order and safety activities',
    label: '84.24 - Public order and safety activities'
  },
  {
    value: '84.25 - Fire service activities',
    label: '84.25 - Fire service activities'
  },
  {
    value: '84.3 - Compulsory social security activities',
    label: '84.3 - Compulsory social security activities'
  },
  {
    value: '85.1 - Pre-primary education',
    label: '85.1 - Pre-primary education'
  },
  {value: '85.2 - Primary education', label: '85.2 - Primary education'},
  {
    value: '85.31 - General secondary education',
    label: '85.31 - General secondary education'
  },
  {
    value: '85.32 - Vocational secondary education',
    label: '85.32 - Vocational secondary education'
  },
  {
    value: '85.33 - Post-secondary non-tertiary education',
    label: '85.33 - Post-secondary non-tertiary education'
  },
  {value: '85.4 - Tertiary education', label: '85.4 - Tertiary education'},
  {
    value: '85.51 - Sports and recreation education',
    label: '85.51 - Sports and recreation education'
  },
  {
    value: '85.52 - Cultural education',
    label: '85.52 - Cultural education'
  },
  {
    value: '85.53 - Driving school activities',
    label: '85.53 - Driving school activities'
  },
  {
    value: '85.59 - Other education n.e.c.',
    label: '85.59 - Other education n.e.c.'
  },
  {
    value: '85.61 - Intermediation service activities for courses and tutors',
    label: '85.61 - Intermediation service activities for courses and tutors'
  },
  {
    value: '85.69 - Educational support activities n.e.c.',
    label: '85.69 - Educational support activities n.e.c.'
  },
  {value: '86.1 - Hospital activities', label: '86.1 - Hospital activities'},
  {
    value: '86.21 - General medical practice activities',
    label: '86.21 - General medical practice activities'
  },
  {
    value: '86.22 - Medical specialists activities',
    label: '86.22 - Medical specialists activities'
  },
  {
    value: '86.23 - Dental practice care activities',
    label: '86.23 - Dental practice care activities'
  },
  {
    value:
      '86.91 - Diagnostic imaging services and medical laboratory activities',
    label:
      '86.91 - Diagnostic imaging services and medical laboratory activities'
  },
  {
    value: '86.92 - Patient transportation by ambulance',
    label: '86.92 - Patient transportation by ambulance'
  },
  {
    value:
      '86.93 - Activities of psychologists and psychotherapists, except medical doctors',
    label:
      '86.93 - Activities of psychologists and psychotherapists, except medical doctors'
  },
  {
    value: '86.94 - Nursing and midwifery activities',
    label: '86.94 - Nursing and midwifery activities'
  },
  {
    value: '86.95 - Physiotherapy activities',
    label: '86.95 - Physiotherapy activities'
  },
  {
    value:
      '86.96 - Traditional, complementary and alternative medicine activities',
    label:
      '86.96 - Traditional, complementary and alternative medicine activities'
  },
  {
    value:
      '86.97 - Intermediation service activities for medical, dental and other human health services',
    label:
      '86.97 - Intermediation service activities for medical, dental and other human health services'
  },
  {
    value: '86.99 - Other human health activities n.e.c.',
    label: '86.99 - Other human health activities n.e.c.'
  },
  {
    value: '87.1 - Residential nursing care activities',
    label: '87.1 - Residential nursing care activities'
  },
  {
    value:
      '87.2 - Residential care activities for persons living with or having a diagnosis of a mental illness or substance abuse',
    label:
      '87.2 - Residential care activities for persons living with or having a diagnosis of a mental illness or substance abuse'
  },
  {
    value:
      '87.3 - Residential care activities for older persons or persons with physical disabilities',
    label:
      '87.3 - Residential care activities for older persons or persons with physical disabilities'
  },
  {
    value:
      '87.91 - Intermediation service activities for residential care activities',
    label:
      '87.91 - Intermediation service activities for residential care activities'
  },
  {value: '87.99 - Other residential', label: '87.99 - Other residential'},
  {
    value: '90.11 - Literary creation and musical composition activities',
    label: '90.11 - Literary creation and musical composition activities'
  },
  {
    value: '90.12 - Visual arts creation activities',
    label: '90.12 - Visual arts creation activities'
  },
  {
    value: '90.13 - Other arts creation activities',
    label: '90.13 - Other arts creation activities'
  },
  {
    value: '90.2 - Activities of performing arts',
    label: '90.2 - Activities of performing arts'
  },
  {
    value: '90.31 - Operation of arts facilities and sites',
    label: '90.31 - Operation of arts facilities and sites'
  },
  {
    value: '90.39 - Other support activities to arts and performing arts',
    label: '90.39 - Other support activities to arts and performing arts'
  },
  {value: '91.11 - Library activities', label: '91.11 - Library activities'},
  {value: '91.12 - Archive activities', label: '91.12 - Archive activities'},
  {
    value: '91.21 - Museum and collection activities',
    label: '91.21 - Museum and collection activities'
  },
  {
    value: '91.22 - Historical site and monument activities',
    label: '91.22 - Historical site and monument activities'
  },
  {
    value:
      '91.3 - Conservation, restoration and other support activities for cultural heritage',
    label:
      '91.3 - Conservation, restoration and other support activities for cultural heritage'
  },
  {
    value: '91.41 - Botanical and zoological garden activities',
    label: '91.41 - Botanical and zoological garden activities'
  },
  {
    value: '91.42 - Nature reserve activities',
    label: '91.42 - Nature reserve activities'
  },
  {
    value: '92 - Gambling and betting activities',
    label: '92 - Gambling and betting activities'
  },
  {
    value: '93.11 - Operation of sports facilities',
    label: '93.11 - Operation of sports facilities'
  },
  {
    value: '93.12 - Activities of sports clubs',
    label: '93.12 - Activities of sports clubs'
  },
  {
    value: '93.13 - Activities of fitness centres',
    label: '93.13 - Activities of fitness centres'
  },
  {
    value: '93.19 - Sports activities n.e.c.',
    label: '93.19 - Sports activities n.e.c.'
  },
  {
    value: '93.21 - Activities of amusement parks and theme parks',
    label: '93.21 - Activities of amusement parks and theme parks'
  },
  {
    value: '93.29 - Amusement and recreation activities n.e.c.',
    label: '93.29 - Amusement and recreation activities n.e.c.'
  },
  {
    value:
      '94.11 - Activities of business and employers membership organisations',
    label:
      '94.11 - Activities of business and employers membership organisations'
  },
  {
    value: '94.12 - Activities of professional membership organisations',
    label: '94.12 - Activities of professional membership organisations'
  },
  {
    value: '94.2 - Activities of trade unions',
    label: '94.2 - Activities of trade unions'
  },
  {
    value: '94.91 - Activities of religious organisations',
    label: '94.91 - Activities of religious organisations'
  },
  {
    value: '94.92 - Activities of political organisations',
    label: '94.92 - Activities of political organisations'
  },
  {
    value: '94.99 - Activities of other membership organisations n.e.c.',
    label: '94.99 - Activities of other membership organisations n.e.c.'
  },
  {
    value:
      '95.1 - Repair and maintenance of computers and communication equipment',
    label:
      '95.1 - Repair and maintenance of computers and communication equipment'
  },
  {
    value: '95.21 - Repair and maintenance of consumer electronics',
    label: '95.21 - Repair and maintenance of consumer electronics'
  },
  {
    value:
      '95.22 - Repair and maintenance of household appliances and home and garden equipment',
    label:
      '95.22 - Repair and maintenance of household appliances and home and garden equipment'
  },
  {
    value: '95.23 - Repair and maintenance of footwear and leather goods',
    label: '95.23 - Repair and maintenance of footwear and leather goods'
  },
  {
    value: '95.24 - Repair and maintenance of furniture and home furnishings',
    label: '95.24 - Repair and maintenance of furniture and home furnishings'
  },
  {
    value: '95.25 - Repair and maintenance of watches, clocks and jewellery',
    label: '95.25 - Repair and maintenance of watches, clocks and jewellery'
  },
  {
    value:
      '95.29 - Repair and maintenance of personal and household goods n.e.c.',
    label:
      '95.29 - Repair and maintenance of personal and household goods n.e.c.'
  },
  {
    value: '95.31 - Repair and maintenance of motor vehicles',
    label: '95.31 - Repair and maintenance of motor vehicles'
  },
  {
    value: '95.32 - Repair and maintenance of motorcycles',
    label: '95.32 - Repair and maintenance of motorcycles'
  },
  {
    value:
      '95.4 - Intermediation service activities for repair and maintenance of computers, personal and household',
    label:
      '95.4 - Intermediation service activities for repair and maintenance of computers, personal and household'
  },
  {
    value: '97 - Activities of households as employers of domestic personnel',
    label: '97 - Activities of households as employers of domestic personnel'
  },
  {
    value:
      '98.1 - Undifferentiated goods-producing activities of private households for own use',
    label:
      '98.1 - Undifferentiated goods-producing activities of private households for own use'
  },
  {
    value:
      '98.2 - Undifferentiated service-producing activities of private households for own use',
    label:
      '98.2 - Undifferentiated service-producing activities of private households for own use'
  },
  {
    value: '99 - Activities of extraterritorial organisations and bodies',
    label: '99 - Activities of extraterritorial organisations and bodies'
  }
];

export const VERIFIER_BODY_OPTIONS = [
  {value: 'Austria', label: 'Austria'},
  {value: 'Belgium', label: 'Belgium'},
  {value: 'Bulgaria', label: 'Bulgaria'},
  {value: 'Croatia', label: 'Croatia'},
  {value: 'Cyprus', label: 'Cyprus'},
  {value: 'Czechia', label: 'Czechia'},
  {value: 'Denmark', label: 'Denmark'},
  {value: 'Estonia', label: 'Estonia'},
  {value: 'Finland', label: 'Finland'},
  {value: 'France', label: 'France'},
  {value: 'Germany', label: 'Germany'},
  {value: 'Greece', label: 'Greece'},
  {value: 'Hungary', label: 'Hungary'},
  {value: 'Ireland', label: 'Ireland'},
  {value: 'Italy', label: 'Italy'},
  {value: 'Latvia', label: 'Latvia'},
  {value: 'Lithuania', label: 'Lithuania'},
  {value: 'Luxembourg', label: 'Luxembourg'},
  {value: 'Malta', label: 'Malta'},
  {value: 'Netherlands', label: 'Netherlands'},
  {value: 'Poland', label: 'Poland'},
  {value: 'Portugal', label: 'Portugal'},
  {value: 'Romania', label: 'Romania'},
  {value: 'Slovakia', label: 'Slovakia'},
  {value: 'Slovenia', label: 'Slovenia'},
  {value: 'Spain', label: 'Spain'},
  {value: 'Sweden', label: 'Sweden'}
];

export const PROCESS_AGGREGATED_OPTIONS = [
  {value: 'Calcined clay', label: 'Calcined clay'},
  {value: 'Cement clinker', label: 'Cement clinker'},
  {value: 'Cement', label: 'Cement'},
  {value: 'Aluminous cement', label: 'Aluminous cement'},
  {value: 'Electricity', label: 'Electricity'},
  {value: 'Nitric acid', label: 'Nitric acid'},
  {value: 'Ammonia', label: 'Ammonia'},
  {value: 'Urea', label: 'Urea'},
  {value: 'Mixed fertilisers', label: 'Mixed fertilisers'},
  {value: 'Sintered ore', label: 'Sintered ore'},
  {value: 'Pig iron', label: 'Pig iron'},
  {value: 'Ferromanganese (FeMn)', label: 'Ferromanganese (FeMn)'},
  {value: 'Ferrochromium (FeCr)', label: 'Ferrochromium (FeCr)'},
  {value: 'Ferronickel (FeNi)', label: 'Ferronickel (FeNi)'},
  {value: 'Direct Reduced Iron (DRI)', label: 'Direct Reduced Iron (DRI)'},
  {value: 'Crude steel', label: 'Crude steel'},
  {value: 'Iron or steel products', label: 'Iron or steel products'},
  {value: 'Unwrought aluminium', label: 'Unwrought aluminium'},
  {value: 'Aluminium products', label: 'Aluminium products'},
  {value: 'Hydrogen', label: 'Hydrogen'}
];

export const PROCESS_ROUTE_OPTIONS = [
  {value: 'Blast Furnace', label: 'Blast Furnace'},
  {value: 'EAF', label: 'EAF'},
  {value: 'Other', label: 'Other'}
];

export const CN_CODE_OPTIONS = [
  {
    value: '2601 12 00 – Agglomerated iron ores',
    label: '2601 12 00 – Agglomerated iron ores'
  },
  {
    value: '7201 – Pig iron & spiegeleisen',
    label: '7201 – Pig iron & spiegeleisen'
  },
  {
    value: '7205 – Granules/powders (partial)',
    label: '7205 – Granules/powders (partial)'
  },
  {value: '7202 1 – Ferro-manganese', label: '7202 1 – Ferro-manganese'},
  {value: '7202 4 – Ferro-chromium', label: '7202 4 – Ferro-chromium'},
  {value: '7202 6 – Ferro-nickel', label: '7202 6 – Ferro-nickel'},
  {value: '7203 – Direct reduced iron', label: '7203 – Direct reduced iron'},
  {
    value: '7206 – Iron/non-alloy steel ingots',
    label: '7206 – Iron/non-alloy steel ingots'
  },
  {
    value: '7207 – Semi-finished iron/non-alloy steel',
    label: '7207 – Semi-finished iron/non-alloy steel'
  },
  {
    value: '7218 – Stainless steel ingots',
    label: '7218 – Stainless steel ingots'
  },
  {
    value: '7224 – Other alloy steel ingots',
    label: '7224 – Other alloy steel ingots'
  },
  {
    value: '7205 – Granules/powders (remainder)',
    label: '7205 – Granules/powders (remainder)'
  },
  {
    value: '7208 – Flat-rolled HR ≥600 mm',
    label: '7208 – Flat-rolled HR ≥600 mm'
  },
  {
    value: '7209 – Flat-rolled CR ≥600 mm',
    label: '7209 – Flat-rolled CR ≥600 mm'
  },
  {
    value: '7210 – Flat-rolled clad ≥600 mm',
    label: '7210 – Flat-rolled clad ≥600 mm'
  },
  {value: '7211 – Flat-rolled <600 mm', label: '7211 – Flat-rolled <600 mm'},
  {
    value: '7212 – Flat-rolled clad <600 mm',
    label: '7212 – Flat-rolled clad <600 mm'
  },
  {
    value: '7213 – Bars and rods HR coils',
    label: '7213 – Bars and rods HR coils'
  },
  {value: '7214 – Other bars and rods', label: '7214 – Other bars and rods'},
  {value: '7215 – Other bars and rods', label: '7215 – Other bars and rods'},
  {
    value: '7216 – Angles, shapes, sections',
    label: '7216 – Angles, shapes, sections'
  },
  {value: '7217 – Wire', label: '7217 – Wire'},
  {
    value: '7219 – Flat-rolled SS ≥600 mm',
    label: '7219 – Flat-rolled SS ≥600 mm'
  },
  {
    value: '7220 – Flat-rolled SS <600 mm',
    label: '7220 – Flat-rolled SS <600 mm'
  },
  {
    value: '7221 – SS bars/rods HR coils',
    label: '7221 – SS bars/rods HR coils'
  },
  {
    value: '7222 – Other SS bars, rods, angles',
    label: '7222 – Other SS bars, rods, angles'
  },
  {value: '7223 – SS wire', label: '7223 – SS wire'},
  {
    value: '7225 – Flat-rolled alloy ≥600 mm',
    label: '7225 – Flat-rolled alloy ≥600 mm'
  },
  {
    value: '7226 – Flat-rolled alloy <600 mm',
    label: '7226 – Flat-rolled alloy <600 mm'
  },
  {
    value: '7227 – Alloy bars/rods HR coils',
    label: '7227 – Alloy bars/rods HR coils'
  },
  {
    value: '7228 – Other alloy bars, rods, hollow drill',
    label: '7228 – Other alloy bars, rods, hollow drill'
  },
  {value: '7229 – Alloy wire', label: '7229 – Alloy wire'},
  {
    value: '7301 – Sheet piling & welded sections',
    label: '7301 – Sheet piling & welded sections'
  },
  {
    value: '7302 – Railway track material',
    label: '7302 – Railway track material'
  },
  {
    value: '7303 – Cast iron tubes/pipes',
    label: '7303 – Cast iron tubes/pipes'
  },
  {
    value: '7304 – Seamless tubes/pipes',
    label: '7304 – Seamless tubes/pipes'
  },
  {
    value: '7305 – Large diameter tubes/pipes',
    label: '7305 – Large diameter tubes/pipes'
  },
  {value: '7306 – Other tubes/pipes', label: '7306 – Other tubes/pipes'},
  {value: '7307 – Tube/pipe fittings', label: '7307 – Tube/pipe fittings'},
  {
    value: '7308 – Structures & structural parts',
    label: '7308 – Structures & structural parts'
  },
  {
    value: '7309 – Large containers >300 L',
    label: '7309 – Large containers >300 L'
  },
  {
    value: '7310 – Small containers ≤300 L',
    label: '7310 – Small containers ≤300 L'
  },
  {value: '7311 – Gas containers', label: '7311 – Gas containers'},
  {value: '7318 – Fasteners', label: '7318 – Fasteners'},
  {value: '7326 – Other articles', label: '7326 – Other articles'}
];

// section 2

export const SOURCE_STREAM_TYPE_OPTIONS = [
  {value: 'Combustion', label: 'Combustion'},
  {value: 'Process Emissions', label: 'Process Emissions'},
  {value: 'Mass Balance', label: 'Mass Balance'}
];

export const MONITORING_METHODOLOGY_OPTIONS = [
  {value: 'Calculation Based', label: 'Calculation Based'},
  {value: 'Measurement Based (CEMS)', label: 'Measurement Based (CEMS)'}
];

export const UNIT_OPTIONS = [
  {value: 'Tonnes (t)', label: 'Tonnes (t)'},
  {value: '1000 Nm3', label: '1000 Nm3'}
];

export const BIOMASS_SUSTAINABILITY_OPTIONS = [
  {value: 'Sustainable', label: 'Sustainable'},
  {value: 'Other', label: 'Other'}
];

export const UNCERTAINTY_OF_DATA_OPTIONS = [
  {value: '< 1.5%', label: '< 1.5%'},
  {value: '< 2.5%', label: '< 2.5%'},
  {value: '< 5.0%', label: '< 5.0%'}
];

export const PREDOMINANT_METHOD_OPTIONS = [
  {value: 'Calculation-based', label: 'Calculation-based'},
  {value: 'Measurement-based', label: 'Measurement-based'}
];

export const JUSTIFICATION_FOR_DEFAULT_VALUES_OPTIONS = [
  {value: 'High costs', label: 'High costs'},
  {value: 'Technical infeasibility', label: 'Technical infeasibility'},
  {value: 'Limited time', label: 'Limited time'}
];

export const QUALITY_ASSURANCE_OPTIONS = [
  {value: 'ISO 14064-1', label: 'ISO 14064-1'},
  {value: 'ISO 9001', label: 'ISO 9001'},
  {value: 'ETS Rules', label: 'ETS Rules'},
  {value: 'None', label: 'None'}
];

export const ELECTRICITY_CONNECTION_OPTIONS = [
  {value: 'Grid connection', label: 'Grid connection'},
  {value: 'Captive Power Plant', label: 'Captive Power Plant'},
  {value: 'Both', label: 'Both'}
];

export const EMISSION_FACTOR_SOURCE_OPTIONS = [
  {value: 'Region Average', label: 'Region Average'},
  {value: 'PPA (Green Power)', label: 'PPA (Green Power)'},
  {value: 'Steel Mill Factor', label: 'Steel Mill Factor'}
];

// SECTION 4
export const CBAM_GOOD_CATEGORY_OPTIONS = [
  {value: 'Sintered Ore', label: 'Sintered Ore'},
  {value: 'Pig Iron', label: 'Pig Iron'},
  {value: 'Crude Steel', label: 'Crude Steel'},
  {value: 'Iron/Steel Products', label: 'Iron/Steel Products'}
];

export const PRODUCTION_ROUTE_OPTIONS = [
  {value: 'Blast Furnace-BOF', label: 'Blast Furnace-BOF'},
  {value: 'EAF', label: 'EAF'},
  {value: 'Smelting Reduction', label: 'Smelting Reduction'}
];

export const MAIN_REDUCTION_AGENT_OPTIONS = [
  {value: 'Coke', label: 'Coke'},
  {value: 'Coal', label: 'Coal'},
  {value: 'Natural Gas', label: 'Natural Gas'},
  {value: 'Hydrogen', label: 'Hydrogen'},
  {value: 'Biomass', label: 'Biomass'}
];

export const MEASURABLE_HEAT_OPTIONS = [
  {value: 'No Heat Transfer', label: 'No Heat Transfer'},
  {value: 'Heat Imported', label: 'Heat Imported'},
  {value: 'Heat Exported', label: 'Heat Exported'}
];

export const WASTE_GAS_USAGE_METHOD_OPTIONS = [
  {value: 'Recycled Internal', label: 'Recycled Internal'},
  {value: 'Sold External', label: 'Sold External'},
  {value: 'Flared', label: 'Flared'}
];

// SECTION 5

export const DATA_SOURCE_OPTIONS = [
  {value: 'Actual Data (Supplier)', label: 'Actual Data (Supplier)'},
  {value: 'Default Values', label: 'Default Values'}
];

// SECTION 6
export const FORM_OF_PRICE_OPTIONS = [
  {value: 'Tax', label: 'Tax'},
  {
    value: 'Emissions Trading System (ETS)',
    label: 'Emissions Trading System (ETS)'
  }
];

export const CURRENCY_OPTIONS = [
  {value: '؋', label: '؋'},
  {value: 'L', label: 'L'},
  {value: 'د.ج', label: 'د.ج'},
  {value: '€', label: '€'},
  {value: 'Kz', label: 'Kz'},
  {value: '$', label: '$'},
  {value: '֏', label: '֏'},
  {value: '.د.ب', label: '.د.ب'},
  {value: '৳', label: '৳'},
  {value: 'Br', label: 'Br'},
  {value: 'Fr', label: 'Fr'},
  {value: 'Nu.', label: 'Nu.'},
  {value: 'Bs.', label: 'Bs.'},
  {value: 'KM', label: 'KM'},
  {value: 'P', label: 'P'},
  {value: 'R$', label: 'R$'},
  {value: 'лв', label: 'лв'},
  {value: '៛', label: '៛'},
  {value: '¥', label: '¥'},
  {value: '₡', label: '₡'},
  {value: 'Kč', label: 'Kč'},
  {value: 'kr', label: 'kr'},
  {value: 'E£', label: 'E£'},
  {value: 'Nfk', label: 'Nfk'},
  {value: 'D', label: 'D'},
  {value: '₵', label: '₵'},
  {value: 'Q', label: 'Q'},
  {value: 'G', label: 'G'},
  {value: 'Ft', label: 'Ft'},
  {value: '₹', label: '₹'},
  {value: 'Rp', label: 'Rp'},
  {value: '﷼', label: '﷼'},
  {value: 'ع.د', label: 'ع.د'},
  {value: '₪', label: '₪'},
  {value: 'د.ا', label: 'د.ا'},
  {value: 'KSh', label: 'KSh'},
  {value: 'د.ك', label: 'د.ك'},
  {value: 'сом', label: 'сом'},
  {value: '₭', label: '₭'},
  {value: 'L£', label: 'L£'},
  {value: 'ل.د', label: 'ل.د'},
  {value: 'CHF', label: 'CHF'},
  {value: 'Ar', label: 'Ar'},
  {value: 'MK', label: 'MK'},
  {value: 'RM', label: 'RM'},
  {value: 'Rf', label: 'Rf'},
  {value: 'UM', label: 'UM'},
  {value: '₨', label: '₨'},
  {value: '₮', label: '₮'},
  {value: 'د.م.', label: 'د.م.'},
  {value: 'MT', label: 'MT'},
  {value: 'K', label: 'K'},
  {value: 'C$', label: 'C$'},
  {value: '₦', label: '₦'},
  {value: '₩', label: '₩'},
  {value: 'ден', label: 'ден'},
  {value: 'B/.', label: 'B/.'},
  {value: '₲', label: '₲'},
  {value: 'S/.', label: 'S/.'},
  {value: '₱', label: '₱'},
  {value: 'zł', label: 'zł'},
  {value: 'lei', label: 'lei'},
  {value: 'T', label: 'T'},
  {value: 'Db', label: 'Db'},
  {value: 'дин.', label: 'дин.'},
  {value: 'Le', label: 'Le'},
  {value: 'Sh', label: 'Sh'},
  {value: 'R', label: 'R'},
  {value: '£', label: '£'},
  {value: 'ج.س.', label: 'ج.س.'},
  {value: 'ЅМ', label: 'ЅМ'},
  {value: '฿', label: '฿'},
  {value: 'T$', label: 'T$'},
  {value: 'د.ت', label: 'د.ت'},
  {value: '₺', label: '₺'},
  {value: 'm', label: 'm'},
  {value: '₴', label: '₴'},
  {value: 'د.إ', label: 'د.إ'},
  {value: 'сўм', label: 'сўм'},
  {value: 'Vt', label: 'Vt'},
  {value: '₫', label: '₫'},
  {value: 'ZK', label: 'ZK'},
  {value: 'ZiG', label: 'ZiG'}
];

export const GOODS_CATEGORY_OPTIONS = [
  {id: 1, value: 'Pig Iron', label: 'Pig Iron'},
  {
    id: 2,
    value: 'Direct reduced iron (DRI)',
    label: 'Direct reduced iron (DRI)'
  },
  {id: 3, value: 'Crude steel', label: 'Crude steel'},
  {id: 4, value: 'Iron or steel products', label: 'Iron or steel products'},
  {id: 5, value: 'Sintered Ore', label: 'Sintered Ore'},
  {
    id: 6,
    value: 'Alloys (FeMn, FeCr, FeNi)',
    label: 'Alloys (FeMn, FeCr, FeNi)'
  }
];

export const ROUTE_OPTIONS = [
  {subId: [1], value: 'Blast furnace', label: 'Blast furnace'},
  {
    subId: [2, 4, 5, 6],
    value: 'All production routes',
    label: 'All production routes'
  },
  {
    subId: [3],
    value: 'Basic oxygen steelmaking (BOF)',
    label: 'Basic oxygen steelmaking (BOF)'
  },
  {subId: [1], value: 'Smelting Reduction', label: 'Smelting Reduction'},
  {
    subId: [1, 3],
    value: 'Unknown production routes',
    label: 'Unknown production routes'
  },
  {
    subId: [1, 3],
    value: 'Other production routes',
    label: 'Other production routes'
  },
  {subId: [3], value: 'Electric arc furnace', label: 'Electric arc furnace'}
];

export const getRouteOptionsForGoodsCategory = (
  selectedGoodsCategory: string | undefined
): typeof ROUTE_OPTIONS => {
  if (!selectedGoodsCategory) {
    return ROUTE_OPTIONS;
  }

  const matchedGoodsCategory = GOODS_CATEGORY_OPTIONS.find(
    (goods) => goods.value === selectedGoodsCategory
  );

  if (!matchedGoodsCategory) {
    return ROUTE_OPTIONS;
  }

  return ROUTE_OPTIONS.filter((route) => {
    if (!route?.subId || !Array.isArray(route.subId)) {
      return true;
    }

    return route.subId.includes(matchedGoodsCategory.id);
  });
};
